<template>
  <div class="container" style="width: 100%;height:100%;overflow-y:auto;" ref="scrollContainer" @scroll="scrollToTop">
    <!-- 面包屑导航 -->
    <breadcrumb :breadcrumbConfig="breadcrumbConfig"></breadcrumb>
    <!--    <breadcrumb></breadcrumb>-->
    <!-- 面包屑导航 -->
    <div id="printContext" @click="printT">
      <!-- 打印 -->
      <printModel style="display: none;" :printData="printData"></printModel>
    </div>
    <div class="content">
      <h2>物流订单</h2>
      <h3>数据筛选</h3>
      <form-filed class="search-form" :formconfig="searchFormConfig.formconfig" :formData="searchFormConfig.formData" @cascaderValue="handlerCascaderValue" @formDataval="dialogClick"
        @formDataval1="dialogClick1" ref="formAttr"></form-filed>
    </div>
    <div class="content">
      <h3>列表数据</h3>
      <div class="but-list">
        <div class="left">
          <el-button v-for="(val, key) in logisticsStatus" :key="key" :disabled="loading" :type="currentStatus === val.values ? 'primary' : 'info'" size="small" plain
            @click="onChangeLogisticsStatus(val.values)">{{ val.title
            }}<span v-if="key === 'stayStockUp' ||
              key === 'stockUp' ||
              key === 'stayDeliverGoods' ||
              key === 'selfPickup'
            ">（{{ val.total }}）</span>
          </el-button>
        </div>
        <div class="right">
          <el-button type="primary" size="small" class="stock-up-send-but2" v-if="currentStatus === logisticsStatus.stayDeliverGoods.values" @click="onUndo()">取消发货
          </el-button>
          <el-button type="primary" size="small" class="stay-stock-up-but" v-if="currentStatus === logisticsStatus.stayStockUp.values" @click="onStockUp(true)">批量备货
          </el-button>
          <span style="color:#FF0000;font-size:14px;margin-right:20px;" v-if="currentStatus === logisticsStatus.stockUp.values">* 生成面单前请确认已拆完订单</span>
          <el-button type="primary" size="small" class="stock-up-send-but1" v-if="currentStatus === logisticsStatus.stockUp.values" @click="openProuductOrder()">生成电子面单
          </el-button>
          <el-button type="primary" size="small" class="stock-up-send-but" v-if="currentStatus === logisticsStatus.stayDeliverGoods.values" @click="onPrintOrder()">打印面单
          </el-button>
          <el-button type="primary" size="small" class="stock-up-send-but" v-if="currentStatus === logisticsStatus.stockUp.values" @click="deriveDeliverGoods1()">导出拣货单
          </el-button>
          <el-button type="primary" size="small" class="stock-up-send-but" v-if="currentStatus === logisticsStatus.stockUp.values" @click="deriveDeliverGoods()">导出发货
          </el-button>
          <el-button type="primary" size="small" class="stock-up-record-but" v-if="currentStatus === logisticsStatus.stockUp.values" @click="onApplierExport('1')">导出记录
          </el-button>
          <el-button type="primary" size="small" class="stay-deliver-goods-but" v-if="currentStatus === logisticsStatus.stayDeliverGoods.values" @click="importLogisticsData(3)">导出
          </el-button>
          <el-button type="primary" size="small" class="stay-deliver-goods-but" v-if="currentStatus === logisticsStatus.all.values" @click="totalExport">导出
          </el-button>
          <el-button type="primary" size="small" class="stay-deliver-goods-but" v-if="currentStatus == 9" @click="totalExport('selfPickupIn')">导出
          </el-button>
          <el-button type="primary" size="small" class="stay-deliver-goods-but" v-if="currentStatus === logisticsStatus.afterSale.values" @click="afterExport">导出
          </el-button>
          <el-button type="primary" size="small" class="stay-deliver-goods-but" v-if="currentStatus === logisticsStatus.stayDeliverGoods.values" @click="leadingIn()">导入物流单
          </el-button>
          <el-button size="small" class="deliver-goods-but" v-if="currentStatus === logisticsStatus.deliverGoods.values" @click="batchAmend">批量修改物流单号
          </el-button>
          <el-button size="small" type="primary" :loading="btnLoading" v-if="currentStatus === logisticsStatus.deliverGoods.values" @click="importLogisticsData(4)">导出物流数据
          </el-button>
          <el-button type="primary" size="small" class="stay-deliver-goods-but" v-if="currentStatus === logisticsStatus.afterSale.values" @click="afterSaleLeadingIn()">批量导入换货单号
          </el-button>
        </div>
      </div>
      <lb-table3 v-if="showTable" v-horizontal-scroll="'always'" v-loading="loadinglist" :tableHeight="tableHeight" @sortChange="handleSortChange" :column="columns" :expandRowKeys="expandRowKeys"
        ref="tableData" :data="page.list" pagination :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50, 200]"
        :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChange" @p-current-change="handleCurrentChange" @selection-change="handleSelectionChange">
      </lb-table3>
    </div>
    <!--========================== el-dialog =================================-->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :append-to-body="true">
      <!-- 进度 -->
      <template v-if="dialog.type === 'shenheStep'">
        <step-progress :orderObj="dialog.row" :processFunc="dictionaries.process_func" type="shenheStep"></step-progress>
      </template>
      <!-- 修改物流单号 发货 -->
      <template v-if="dialog.type === 'modifyOrderNoOne'">
        <modify-order-no :orderObj="dialog.row" :type="dialog.type" source="service" ref="modifyOrderNo" @submitState="modifyState"></modify-order-no>
      </template>
      <!-- 物流异常 -->
      <template v-if="dialog.type === 'wuliuAbnormal'">
        <div class="wuliuAbnormal_box">
          <div class="wuliuAbnormal_box_title">异常原因</div>
          <div class="radio_group">
            <el-radio-group v-model="wuliuStatus.resource">
              <el-radio class="radio_group_item" v-for="(item, index) in dictionaries.logistics_exception_reason" :key="index" style="display: block" :label="item.dictId">{{ item.dictName }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <el-form label-width="65px" class="audit_textarea">
          <el-form-item label="备注">
            <el-input placeholder="请输入备注" maxlength="200" show-word-limit type="textarea" v-model="wuliuStatus.remark"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialogBtnright dialogBtnright_right" style="margin-top: 20px">
          <el-button class="setPay_payment_btn_quxiao" @click="dialog.visible = false">取 消</el-button>
          <el-button class="setPay_payment_btn_queren" type="primary" @click="handlerAuditsubmit">确 定</el-button>
        </div>
      </template>
      <template v-if="dialog.type === 'logisticsMessageOne'">
        <step-progress :orderObj="dialog.row" type="logisticsMessageOne" source="service"></step-progress>
      </template>
      <!-- 缺货弹窗 -->
      <template v-if="dialog.type === 'outStock'">
        <template>
          <p>该订单是否要做缺货处理？</p>
        </template>
        <div class="dialogBtnright dialogBtnright_right" style="margin-top: 20px">
          <el-button class="setPay_payment_btn_quxiao" @click="dialog.visible = false">取 消</el-button>
          <el-button class="setPay_payment_btn_queren" type="primary" @click="onOutStock">确 定</el-button>
        </div>
      </template>
      <template v-if="dialog.type === 'closeOrder'">
        <!-- {{dialog.row}} v-if="dialog.row.orderGenerateType == 1" -->
        <template v-if="dialog.row.orderGenerateType == 1">
          <el-radio-group v-model="setCloseOrder">
            <el-radio v-for="(item, index) in dictionaries.order_main_close_reason" :key="index" class="setPay_payment" :label="item.dictId">{{ item.dictName }}
            </el-radio>
          </el-radio-group>
        </template>
        <template v-else>
          <p>第三方的自动订单不能关闭</p>
        </template>

        <div class="dialogBtnright dialogBtnright_right" style="margin-top: 20px">
          <el-button class="setPay_payment_btn_quxiao" @click="dialog.visible = false">取 消</el-button>
          <el-button class="setPay_payment_btn_queren" type="primary" @click="handlerCloseOrderSubmit" v-if="dialog.row.orderGenerateType == 1">确 定</el-button>
        </div>
      </template>
      <template v-if="dialog.type === 'deriveRecord'">
        <lb-table :column="columnsDeriveRecord" :data="deriveRecordList.list" pagination :total="deriveRecordList.totalNum" layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]" :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChangeDeriveRecord"
          @p-current-change="handleCurrentChangeDeriveRecord">
        </lb-table>
      </template>
      <template v-if="dialog.type === 'deriveFailOrder'">
        <div style="text-align: center; margin: 20px 0; font-size: 16px">
          <p>
            是否导出共<span>{{ pageTotalNum }}</span>条{{ titleName }}记录？
          </p>
        </div>
      </template>
      <template v-if="dialog.type === 'deriveDeliverGoods'">
        <div style="text-align: center; margin: 10px 0; font-size: 16px">
          <p>
            是否继续导出？
          </p>
        </div>
      </template>
      <template v-if="dialog.type === 'deriveDeliverGoods1'">
        <div style="text-align: center; margin: 10px 0; font-size: 16px">
          <p>
            导出订单共有<span style="color:red;font-weight: bold;">{{ pageTotalNum }}</span>条，是否确认导出？
          </p>
        </div>
      </template>
      <div class="btnClass" v-if="dialog.type !== 'closeOrder' &&
        dialog.type !== 'logisticsMessage' &&
        dialog.type !== 'editWuliu' &&
        dialog.type !== 'modifyOrderNoOne' &&
        dialog.type !== 'logisticsMessageOne' &&
        dialog.type != 'wuliuAbnormal' &&
        dialog.type != 'shenheStep' &&
        dialog.type != 'outStock'
      ">
        <el-button type="primary" plain @click="
          dialog.type == 'deriveRecord' || dialog.type == 'deriveDeliverGoods' || dialog.type == 'deriveFailOrder' || dialog.type == 'deriveDeliverGoods1'
            ? (dialog.visible = false)
            : closeDialog
          ">
          取消
        </el-button>
        <el-button v-if="dialog.type !== 'deriveDeliverGoods' && dialog.type !== 'deriveDeliverGoods1' && dialog.type !== 'deriveFailOrder'" type="primary" @click="
          dialog.type == 'deriveRecord'
            ? (dialog.visible = false)
            : actionDialog
          ">确认
        </el-button>
        <el-button v-if="dialog.type === 'deriveDeliverGoods'" type="primary" @click="deriveDownload">确认</el-button>
        <el-button v-if="dialog.type === 'deriveFailOrder'" type="primary" @click="deriveDownload1">确认</el-button>
        <el-button v-if="dialog.type === 'deriveDeliverGoods1'" type="primary" @click="deriveDownload2">确认</el-button>
      </div>

      <div v-if="dialog.type === 'modifyOrderNoOne'" class="dialog-btn">
        <el-button class="setPay_payment_btn_quxiao" type="primary" plain @click="closeDialog">取消</el-button>
        <el-button class="setPay_payment_btn_queren" type="primary" @click="actionDialog">确认</el-button>
      </div>
    </el-dialog>
    <!--=========================== el-dialog end================================-->
    <!-- 导入物流单-->
    <el-dialog :title="dialoglogistics.title" :visible.sync="dialoglogistics.visible" :width="dialoglogistics.width" :append-to-body="true">
      <template v-if="dialoglogistics.type == 'importlogistics' ||
        dialoglogistics.type == 'batchAmend' ||
        dialoglogistics.type == 'afterSaleLeadingIn'
      " class="importlogistics">
        <div class="popIn">
          <el-upload ref="tops" class="upload-demo" accept=".doc,.docx,.xls,.xlsx,.csv" drag action="#" :multiple="false" :http-request="orderImport" :limit="1">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </div>
        <div class="dialog-footer">
          <div @click="downloadTemplate">
            <el-button type="text" icon="el-icon-download">导入模板下载</el-button>
          </div>
          <div>
            <el-button class="cancel" @click="
              dialoglogistics.visible = false;
            $refs['tops'].clearFiles();">取消
            </el-button>
            <el-button class="affirm" type="primary" @click="
              templateMode();
            $refs['tops'].clearFiles();
            ">确定
            </el-button>
          </div>
        </div>
      </template>
      <template v-if="dialoglogistics.type == 'importlogisticslast' ||
        dialoglogistics.type == 'batchAmendlast' ||
        dialoglogistics.type == 'afterSaleLeadingInlast'
      " class="logisticsTable">
        <el-table :data="importLogisticsList.list" style="width: 100%" :header-cell-style="{ background: '#f8f8f8' }">
          <el-table-column prop="date" label="订单号" width="184">
            <template slot="header" slot-scope="scope">
              <el-tooltip class="item" effect="dark" placement="top">
                <span style="color: red">*</span>
              </el-tooltip>
              订单号
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.orderNo" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="物流单号" width="184">
            <template slot="header">
              <el-tooltip class="item" effect="dark" placement="top">
                <span style="color: red">*</span>
              </el-tooltip>
              物流单号
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.logisticsNumber" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="address" label="物流公司" width="184">
            <template slot="header">
              <el-tooltip class="item" effect="dark" placement="top">
                <span style="color: red">*</span>
              </el-tooltip>
              物流公司
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.logisticsCompany" filterable clearable placeholder="请选择" size="mini">
                <el-option v-for="item in dictionaries.courier_company" :key="item.dictId" :label="item.dictName" :value="item.dictId">
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column prop="address" label="出货仓库（选填）" width="184">
            <template slot-scope="scope">
              <el-select v-model="scope.row.commWarehouseId" clearable placeholder="请选择" size="mini">
                <el-option v-for="item in commWarehouseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="失败理由">
            <template slot-scope="scope">
              {{ scope.row.failureReason }}
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @size-change="handleSizeLogisticsTable" @current-change="handleCurrentLogisticsTable" :current-page="currentPage1" :page-sizes="[10, 20, 50, 100, 200]"
            :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="importLogisticsList.totalNum" prev-text="上一页" next-text="下一页">
          </el-pagination>
        </div>
        <div class="dialogBtnright" style="margin-top: 20px">
          <div>
            <el-button type="text" icon="el-icon-download" @click="downloadThisLocality">下载到本地</el-button>
          </div>
          <div>
            <el-button class="setPay_payment_btn_quxiao" @click="dialoglogistics.visible = false">取 消</el-button>
            <el-button class="setPay_payment_btn_queren" type="primary" @click="resubmit">重新提交</el-button>
          </div>
        </div>
      </template>
    </el-dialog>

    <!-- 物流单号导入 -->
    <!-- 生成电子面单 -->
    <el-dialog title="生成电子面单" :visible.sync="isProductOrder" width="80%" :append-to-body="true" :close-on-click-modal="false">
      <div class="content">
        <!-- <form-filed class="search-form" :formconfig="searchFormConfig1.formconfig" :formData="searchFormConfig1.formData"
          @cascaderValue="handlerCascaderValueDan" @formDataval="dialogClickDan" ref="formAttrx"></form-filed>-->
        <div style="margin-bottom: 10px;">
          <el-form :model="searchFormConfig1.formData" label-width="82px" :inline="true" ref="formAttrxsc">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="searchFormConfig1.formData.orderNo" size="small" placeholder="请输入订单编号" style="width: 232px;"></el-input>
            </el-form-item>
            <el-form-item label="收货人信息" prop="postInfo">
              <el-input v-model="searchFormConfig1.formData.postInfo" size="small" placeholder="请输入收货人信息" style="width: 232px;"></el-input>
            </el-form-item>
            <el-form-item label="提交时间" prop="createdTime">
              <el-date-picker style="width: 232px;" type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="searchFormConfig1.formData.createdTime"
                :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="留言/备注" prop="remark">
              <el-input style="width: 232px;" v-model="searchFormConfig1.formData.remark" size="small" placeholder="请输入留言/备注"></el-input>
            </el-form-item>
            <el-form-item label="物流公司" prop="logisticsCompanyCode">
              <el-select style="width: 232px;" v-model="searchFormConfig1.formData.logisticsCompanyCode" placeholder="请选择物流公司" clearable size="small">
                <el-option v-for="(item, index) of logisticsCompanyList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" plain @click="dialogClickDan('search')">查询</el-button>
              <el-button type="primary" size="small" plain @click="dialogClickDan('reset')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="display: flex;justify-content: start;margin-bottom: 10px;">
          <div class="stock-up-send-but2" @click="openFailOrder()">失败面单({{ ebillErrorCount }})
          </div>
          <div class="stock-up-send-but5" style="margin-left: 20px;" @click="showAddrDialogFn('')">寄件地址设置
          </div>
          <div class="stock-up-send-but1" style="width:120px;margin-right:20px;line-height:36px;cursor:pointer;" @click="openShowCode">月结编码</div>
          <div class="stock-up-send-but3" style="margin-left: 0;" @click="showSelectLogistics(1)">批量选择物流
          </div>
        </div>
        <lb-table v-horizontal-scroll="'always'" ref="sctable" :isBorder="true" :tableRowStyle="tableRowStyle" v-loading="loadinglist" :column="columns1" :data="tableListx" pagination
          :total="totalNumDan" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50, 200]" :current-page.sync="currentPageDan" :page-size="pageSizeDan"
          @size-change="handleSizeChangeDan" @p-current-change="handleCurrentChangeDan" @selection-change="handleSelectionChangeDan">
        </lb-table>
      </div>
      <div style="display: flex;justify-content: end;margin-top: 10px;margin-bottom: 10px;">
        <div class="cBtn" @click="isProductOrder = false">取消</div>
        <div class="qBtn" @click="createEbillBatch()">生成电子面单</div>
      </div>
    </el-dialog>
    <!-- 生成电子面单 -->
    <!-- 生成电子面单结果 -->
    <el-dialog title="生成电子面单" :visible.sync="isROrder" width="30%" :append-to-body="true" :before-close="qProuductOrder">
      <div class="content">
        <div style="font-size: 16px;">已成功生成电子面单<span style="color:#12AB62">{{ successNum }}条</span>,失败<span style="color:#FF0000">{{ failNum }}条</span>！</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="qProuductOrder">取消</div>
          <div class="qBtn" @click="qProuductOrder">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 生成电子面单结果 -->
    <!-- 失败面单 -->
    <el-dialog title="失败面单" :visible.sync="failOrder" width="72%" :append-to-body="true">
      <div class="content">
        <div style="margin-bottom: 10px;">
          <el-form :model="searchFormConfig2.formData" label-width="82px" :inline="true" ref="formAttrx">
            <el-form-item label="生成批次" prop="batchNo">
              <el-input v-model="searchFormConfig2.formData.batchNo" size="small" placeholder="请输入生成批次" style="width: 232px;"></el-input>
            </el-form-item>
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="searchFormConfig2.formData.orderNo" size="small" placeholder="请输入订单编号" style="width: 232px;"></el-input>
            </el-form-item>
            <el-form-item label="收货人信息" prop="postInfo">
              <el-input v-model="searchFormConfig2.formData.postInfo" size="small" placeholder="请输入收货人信息" style="width: 232px;"></el-input>
            </el-form-item>
            <el-form-item label="提交时间" prop="createdTime">
              <el-date-picker style="width: 232px;" type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="searchFormConfig2.formData.createdTime"
                :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="留言/备注" prop="remark">
              <el-input style="width: 232px;" v-model="searchFormConfig2.formData.remark" size="small" placeholder="请输入留言/备注"></el-input>
            </el-form-item>
            <el-form-item label="物流公司" prop="logisticsCompanyCode">
              <el-select style="width: 232px;" v-model="searchFormConfig2.formData.logisticsCompanyCode" placeholder="请选择物流公司" clearable size="small">
                <el-option v-for="(item, index) of logisticsCompanyList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" plain @click="dialogClickFailDan('search')">查询</el-button>
              <el-button type="primary" size="small" plain @click="dialogClickFailDan('reset')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="display: flex;justify-content: start;margin-bottom: 10px;">
          <div class="stock-up-send-but5" @click="exportFailOrder">导出发货</div>
          <div class="stock-up-send-but4" @click="onApplierExport('3')">导出记录</div>
          <div class="stock-up-send-but3" @click="showSelectLogistics(2)">批量重新生成</div>
        </div>
        <lb-table v-horizontal-scroll="'always'" :isBorder="true" ref="sbtable" :tableRowStyle="tableRowStyle" v-loading="loadinglist" :column="columns2" :data="ebillErrorOrderList" pagination
          :total="totalNumFailDan" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50, 200]" :current-page.sync="currentPageFailDan" :page-size="pageSizeFailDan"
          @size-change="handleSizeFailDanChange" @p-current-change="handleCurrentChangeFailDan" @selection-change="handleSelectionChangeFailDan">
        </lb-table>
      </div>
    </el-dialog>
    <!-- 失败面单 -->
    <!-- 打印面单 -->
    <el-dialog title="打印电子面单" :visible.sync="isPrintOrder" width="80%" :append-to-body="true" :close-on-click-modal="false">
      <div class="content">
        <!-- <form-filed class="search-form1" :formconfig="searchFormConfig3.formconfig" :formData="searchFormConfig3.formData"
          @cascaderValue="handlerCascaderValue" @formDataval="dialogClick3" @formDataval1="dialogClick4"
          ref="formAttr1"></form-filed> -->
        <div style="margin-bottom: 10px;">
          <el-form :model="searchFormConfig3.formData" label-width="100px" :inline="true" ref="searchForm1">
            <el-form-item label="生成批次" prop="batchNo">
              <el-input v-model="searchFormConfig3.formData.batchNo" size="small" placeholder="请输入生成批次" style="width: 232px;"></el-input>
            </el-form-item>
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="searchFormConfig3.formData.orderNo" size="small" placeholder="请输入订单编号" style="width: 232px;"></el-input>
            </el-form-item>
            <el-form-item label="运单号" prop="logisticsNo">
              <el-input v-model="searchFormConfig3.formData.logisticsNo" size="small" placeholder="请输入运单号" style="width: 232px;"></el-input>
            </el-form-item>
            <el-form-item label="快递公司" prop="logisticsCompanyCode">
              <el-select style="width: 232px;" v-model="searchFormConfig3.formData.logisticsCompanyCode" @change="fetchData3" placeholder="请选择快递公司" clearable size="small">
                <el-option v-for="(item, index) of logisticsCompanyList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否子母件" prop="multipleBagFlag">
              <el-select style="width: 232px;" v-model="searchFormConfig3.formData.multipleBagFlag" placeholder="请选择是否子母件" clearable size="small">
                <el-option value="true" label="是"></el-option>
                <el-option value="false" label="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="打印时间" prop="printTime" v-if="currentStatus1 != 5">
              <el-date-picker style="width: 232px;" type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="searchFormConfig3.formData.printTime"
                :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="生成面单时间" prop="createdTime">
              <el-date-picker style="width: 232px;" type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="searchFormConfig3.formData.createdTime"
                :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="下单时间" prop="orderTime">
              <el-date-picker style="width: 232px;" type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="searchFormConfig3.formData.orderTime"
                :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="撤销时间" prop="cancelTime" v-if="currentStatus1 == 5">
              <el-date-picker style="width: 232px;" type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="searchFormConfig3.formData.cancelTime"
                :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" plain @click="fetchData3('search')">查询</el-button>
              <el-button type="primary" size="small" plain @click="fetchData3('reset')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="display: flex;justify-content: space-between;margin-bottom: 10px;">
          <div class="left">
            <el-button v-for="(val, key) in logisticsStatus1" :key="key" :disabled="loading" :type="currentStatus1 === val.values ? 'primary' : 'info'" size="small" plain
              @click="onChangeLogisticsStatus1(val.values)">{{ val.title
              }}<span>（{{ val.total }}）</span>
            </el-button>
          </div>
          <div style="display: flex;">
            <div class="stock-up-send-but3" @click="lotsPrintOrder" style="margin-right: 20px;" v-if="currentStatus1 == 2 && isPreview1">批量预览打印</div>
            <div class="stock-up-send-but5" v-if="currentStatus1 == 2 || currentStatus1 == '3'" @click="exportPickOrder">
              导出拣货单</div>
            <div class="stock-up-send-but4" v-if="currentStatus1 == '2'" @click="onApplierExport('2')">导出记录</div>
            <div class="stock-up-send-but5" v-if="currentStatus1 == '' || currentStatus1 == '5'" @click="exportPrintOrder" style="margin-left: 10px;">
              导出</div>
            <!-- <el-button type="primary" size="small" class="stock-up-send-but" @click="isExportPrint = true">导出打印
            </el-button>
            <el-button type="primary" size="small" class="stock-up-send-but">导出记录
            </el-button> -->
          </div>

        </div>
        <lb-table v-horizontal-scroll="'always'" v-loading="loadinglist" :column="columns3" :data="printOrderList" pagination :total="totalNum3" layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50, 200]" :current-page.sync="pageNo3" :page-size="pageSize3" @size-change="handleSizeChange3" @p-current-change="handleCurrentChange3"
          @selection-change="handleSelectionChange3">
        </lb-table>
      </div>
    </el-dialog>
    <!-- 打印面单 -->
    <!-- 批量选择物流 -->
    <el-dialog :title="titleLogistics" :visible.sync="isSelectLogistics" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 25px;">{{ isBatch == 1 ?
          '批量选择物流' : '批量重新生成' }}</span>
        <span style="color:#4168E7">（已选{{ waitOrderList.length }}条订单）</span>
      </div>
      <div class="content">
        <el-form ref="logisticsForm" :model="batchLogistics" :rules="batchRules" label-width="120px" style="margin-top: 10px;">
          <el-form-item label="物流公司" prop="logisticsCompanyCode" style="margin-bottom: 20px;">
            <el-select placeholder="请选择物流公司" v-model="batchLogistics.logisticsCompanyCode" style="width: 100%" @change="selectLD($event)">
              <el-option v-for="item in logisticsCompanyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月结编号" prop="logisticsCustomerCode" style="margin-bottom: 20px;">
            <el-select placeholder="请选择月结编号" v-model="batchLogistics.logisticsCustomerCode" style="width: 100%">
              <el-option v-for="item in monthCodeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="寄件产品类型" prop="logisticsProductType" style="margin-bottom: 20px;">
            <el-select placeholder="请选择寄件产品类型" v-model="batchLogistics.logisticsProductType" style="width: 100%">
              <el-option v-for="item in productTypeList" :key="item.productTypeCode" :label="item.productTypeName" :value="item.productTypeCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="寄件人信息" prop="sendAddressId" style="margin-bottom: 20px;">
            <el-select placeholder="请选择寄件人信息" v-model="batchLogistics.sendAddressId" style="width: 100%">
              <el-option v-for="item in tableAddressList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打印备注" prop="logisticsPrintRemark" v-if="isBatch == 1">
            <el-input type="textarea" v-model="batchLogistics.logisticsPrintRemark" placeholder="请输入打印备注" maxlength="200" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex;justify-content: end;margin-top: 40px;margin-bottom: 10px;">

          <div class="cBtn" @click="isSelectLogistics = false; waitOrderList = []; clearSelection()">取消</div>
          <div class="qBtn" @click="batchLogisticsFn">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 批量选择物流 -->
    <!-- 寄件地址设置 -->
    <el-dialog title="寄件地址设置" :visible.sync="showAddrDialog" width="38.1%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 25px;">寄件地址设置</span>
      </div>
      <div class="content">
        <el-table :data="addressList" style="width: 100%" border :header-cell-style="{ background: '#f7f7f7' }">
          <el-table-column prop="name" label="寄件人姓名" width="160">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="寄件人电话" width="160">
            <template slot-scope="scope">
              <el-input v-model="scope.row.phone"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="寄件地址" width="290">
            <template slot-scope="scope">
              <el-input v-model="scope.row.address"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" size="small" style="color:red;" @click="delAddr(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;font-size: 16px;color:#4168E7;width:100%;height:56px;line-height:56px;border:1px solid #4168E7;cursor:pointer;" @click="addAddr">
          +添加
        </div>
        <div style="display: flex;justify-content: center;margin-top: 20px;margin-bottom: 10px;">
          <!-- <div class="cBtn" @click="showAddrDialog = false">取消</div> -->
          <div class="qBtn" @click="saveAddr">保存</div>
        </div>
      </div>
    </el-dialog>
    <!-- 寄件地址设置 -->
    <!-- 月结编码 -->
    <el-dialog title="月结编码" :visible.sync="showCodeDialog" width="40.4%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 25px;">月结编码</span>
      </div>
      <div class="content">
        <div style="margin-bottom: 20px;" v-for="(item, index) in codeList" :key="index">
          <div style="display:flex;align-items:center;margin-bottom: 8px;">
            <span style="margin-right: 12px;font-size: 16px;color: #333;">{{ item.company }}</span>
            <el-button type="primary" plain size="small" @click="addCode('add', item.code)">添加</el-button>
          </div>
          <el-table :data="item.list" style="width: 100%" border :header-cell-style="{ background: '#f7f7f7' }" v-if="item.list.length > 0">
            <el-table-column prop="companyName" label="主体公司" width="160"></el-table-column>
            <el-table-column prop="code" label="月结编码" width="160"></el-table-column>
            <el-table-column prop="number" label="代收账号" width="290">
              <template slot-scope="scope">
                <p>开户银行：{{ scope.row.collectionBank }}</p>
                <p>姓名：{{ scope.row.collectionName }}</p>
                <p>卡号：{{ scope.row.collectionAccount }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="addCode('edit', scope.row.logisticsCompanyCode, scope.row.id, scope.row)">编辑</el-button>
                <el-button type="text" size="small" style="color:red;" @click="deleteCode(scope.row.logisticsCompanyCode, scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex;justify-content: center;margin-top: 20px;margin-bottom: 10px;">
          <!-- <div class="cBtn" @click="showCodeDialog = false">取消</div> -->
          <div class="qBtn" @click="showCodeDialog = false">保存</div>
        </div>
      </div>
    </el-dialog>
    <!-- 月结编码 -->
    <!-- 新增月结编码 -->
    <el-dialog :title="titleLogistics" :visible.sync="showNewCodeDialog" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 25px;" v-if="this.optionCodeType == 'add'">新增月结编码</span>
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 25px;" v-else>编辑月结编码</span>
      </div>
      <div class="content">
        <el-form ref="infoFormC" label-width="100px" style="margin-top: 10px;">
          <el-form-item label="主体公司">
            <el-input type="text" placeholder="请输入主体公司" v-model="infoFormC.companyName"></el-input>
          </el-form-item>
          <el-form-item label="月结编号">
            <el-input type="text" placeholder="请输入月结编码" v-model="infoFormC.code"></el-input>
          </el-form-item>
          <el-form-item label="开户银行">
            <el-input type="text" placeholder="请输入开户银行" v-model="infoFormC.collectionBank"></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input type="text" placeholder="请输入持卡人姓名" v-model="infoFormC.collectionName"></el-input>
          </el-form-item>
          <el-form-item label="卡号">
            <el-input type="text" placeholder="请输入银行卡卡号" v-model="infoFormC.collectionAccount"></el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex;justify-content: end;margin-top: 40px;margin-bottom: 10px;">

          <div class="cBtn" @click="showNewCodeDialog = false">取消</div>
          <div class="qBtn" @click="submitCode">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 新增月结编码 -->
    <!-- 撤销订单 -->
    <el-dialog title="撤销面单" :visible.sync="isCOrder" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;">撤销面单</span>
      </div>
      <div class="content">
        <div style="font-size: 16px;">是否确认【撤销】该订单的电子面单？撤销后其【<span style="color:red">子母单面单</span>】也会撤销！</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="isCOrder = false">取消</div>
          <div class="qBtn" @click="submitCmorder">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 撤销订单 -->
    <!-- 撤销拆单 -->
    <el-dialog title="撤销拆单" :visible.sync="isSOrder" width="643px" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;" v-if="sType == 0">撤销拆单</span>
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;" v-if="sType == 1">母订单撤销拆单</span>
        <!-- <div class="button-right">
          <span style="margin-top: 8px;" class="title-close" @click="isSOrder = false"></span>
        </div> -->
      </div>

      <div class="content">
        <div style="font-size: 16px;font-family: PingFang SC;font-weight: 400;line-height: 0px;color: #333333;margin-left: 20px;">
          是否确认撤销拆单？
        </div>
        <div style="width: 580px;min-height: 62px;background: #F5F8FF;opacity: 1;border-radius: 0px;margin-top:20px;margin-left: 20px;">
          <div style="padding:8px 12px">
            注意：撤销后，<span v-if="sType == 0">原</span><span v-if="sType == 1">母</span>订单拆单的所有订单<span style="color:red">【<span v-if="sType == 0">合计母订单{{ isNum }}条 </span><span v-if="sType == 1">合计子订单{{
              isNum
            }}条</span>】</span>都撤销拆单！是否确认拆单？</div>
        </div>
        <div style="display: flex;justify-content: end;margin-top: 20px;">
          <div class="cBtn" @click="isSOrder = false">取消</div>
          <div class="qBtn" @click="qSumitSplit">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 撤销拆单 -->
    <!-- 打印面单 -->
    <el-dialog title="打印面单" :visible.sync="printOrderDialog" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;">打印面单</span>
      </div>
      <div class="content">
        <div style="font-size: 16px;">确认打印所选订单的电子面单？</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="printOrderDialog = false">取消</div>
          <div class="qBtn" id="printContext" @click="printT">确认
            <printModel style="display: none;" :printData="printData"></printModel>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 打印面单 -->
    <!-- 导出打印 -->
    <el-dialog title="批量打印" :visible.sync="isExportPrint" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;">批量打印</span>
      </div>
      <div class="content">
        <div style="font-size: 16px;">确认批量打印所选订单的电子面单？</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="isExportPrint = false">取消</div>
          <div class="qBtn" @click="lotPrintSubmit">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 导出打印 -->
    <!-- 重打 -->
    <el-dialog title="重打面单" :visible.sync="isAgainPrint" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;">重打面单</span>
      </div>
      <div class="content">
        <div style="font-size: 16px;">是否确认重新打印该订单的电子面单？</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="isAgainPrint = false">取消</div>
          <div class="qBtn">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 重打 -->
    <!-- 删除月结编码 -->
    <el-dialog title="提示信息" :visible.sync="isDeleteCode" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;">提示信息</span>
      </div>
      <div class="content">
        <div style="font-size: 16px;">删除后不可恢复数据，是否继续？</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="isDeleteCode = false">取消</div>
          <div class="qBtn" @click="submitDeleteCode">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 删除月结编码 -->
    <!-- 选择打印模板 -->
    <el-dialog title="选择打印模板" :visible.sync="isPrintM" width="30%" :append-to-body="true">
      <div class="content">
        <div style="display: flex;justify-content: space-between;flex-wrap:wrap;">
          <div v-for="(item, index) in printModels" :key="index" @click="selectPrintModel(item, index)" style="width:172px" :class="{ activeModel: index == printModelIndex }">
            <div><img src="../../assets/img_moban.png" style="width: 128px;height: 128px;margin-top: 32px;margin-left: 22px;"></div>
            <div style="padding:17px 17px;font-family: PingFang SC;font-size: 14px;font-weight: bold;line-height: 20px;color: #333333;">
              {{ item.name }}</div>
          </div>
        </div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="isPrintM = false">取消</div>
          <div class="qBtn" @click="printModelData">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 选择打印模板 -->
    <!-- 预览 -->
    <el-dialog title="预览" :visible.sync="isPreview" width="30%" :append-to-body="true">
      <div class="content">
        <div style="height: 600px;overflow-y: auto;" v-if="isDB">
          <printModel :printData="printData" style="margin-left: 100px;"></printModel>
        </div>

        <iframe v-else :src="pdfUrl" style="width: 100%;height: 600px;"></iframe>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="qBtn" @click="isPreview = false">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 预览 -->
  </div>
</template>

<script>
import formFiled from '@/components/form/index'
import breadcrumb from '@/components/breadcrumb'
import LbTable from '@/components/lb-table2/lb-table'
import LbTable3 from '@/components/lb-table3/lb-table'
import CloseOrder from './components/CloseOrder'
import StepProgress from '@/components/StepProgress'
import modifyOrderNo from './components/modifyOrderNo'

import mixinsCommon from './mixins/common.js'
// import M from 'minimatch'
import { before } from 'xe-utils/methods'
import { printTest } from '@/utils/myPrintKit.js'
import printModel from './components/printModel'
export default {
  mixins: [mixinsCommon],
  components: {
    formFiled,
    breadcrumb,
    LbTable,
    LbTable3,
    CloseOrder,
    StepProgress,
    modifyOrderNo,
    printModel
  },
  data() {
    return {
      extraStatus: '',
      printOrderDialog: false,
      pdfUrl: '',
      printModelIndex: 0,
      isPrintM: false,
      printModels: [],
      isBatch: 1,
      isF: false,
      dIds: [],
      isDeleteCode: false,
      infoFormC: {
        id: '',
        companyName: '',
        code: '',
        collectionBank: '',
        collectionAccount: '',
        collectionName: '',
        ebillCompanyCode: ''
      },
      expandRowKeys: [],
      parArray: [], // 按钮权限
      showNewCodeDialog: false,
      showCodeDialog: false,
      codeList: [
        {
          company: '京东快递', code: 'JD', list: [

          ]
        },
        {
          company: '德邦快递', code: 'DB', list: [

          ]
        },
        {
          company: 'EMS快递', code: 'EMS', list: [

          ]
        },
        {
          company: '圆通快递', code: 'YTO', list: [

          ]
        },
        {
          company: '中通快递', code: 'ZT', list: [

          ]
        },
      ],
      addressList: [],
      tableAddressList: [],
      showAddrDialog: false,
      tableHeight: '',
      isAgainPrint: false,
      isROrder: false,
      successNum: 0,
      failNum: 0,
      waitOrderList: [],
      isSOrder: false,
      logisticsCompanys: [],
      isExportPrint: false,
      isCOrder: false,
      isPrintOrder: false,
      titleLogistics: '批量选择物流 已选（0）',
      isProductOrder: false,
      failOrder: false,
      isSelectLogistics: false,
      formType: '',
      loadinglist: false,
      btnLoading: false, // 导出物流数据加载
      titleName: '', //
      loading: false,
      sessionDictionaries: {}, // 缓存字典
      wuliuStatus: {
        resource: '',
        remark: ''
      },
      wuliuAbnormalId: '',
      currentPage1: 1,
      pageTotalNum: '', // 待备货商品的数量
      commWarehouseList: '', // 仓库数据
      importLogisticsList: [], // 导入物流单号失败的数据
      file: '', // 文件上传
      setCloseOrder: '', // 关闭原因选择值
      dialoglogistics: { visible: false, title: '编辑', type: '', row: {}, batch: false }, // 导入物流单号
      deriveRecordList: [], // 导出记录列表数据
      currentStatus: '',
      currentStatus1: '',
      logisticsStatus: {
        all: { title: '全部', values: '', total: 0 }, // 全部
        selfPickup: { title: '自提中', values: 9, total: 0 }, // 自提中
        stayStockUp: { title: '待备货', values: 1, total: 0 }, // 待备货
        stockUp: { title: '已备货', values: 2, total: 0 }, // 已备货
        stayDeliverGoods: { title: '待发货', values: 3, total: 0 }, // 待发货
        deliverGoods: { title: '已发货', values: 4, total: 0 }, // 已发货
        yAccept: { title: '已收货', values: 6, total: 0 }, // 已收货
        yClose: { title: '已关闭', values: 7, total: 0 }, // 已关闭
        afterSale: { title: '售后件', values: 5, total: 0 } // 售后件
      },
      logisticsStatus1: {
        all: { title: '全部', values: '', total: 0 }, // 全部
        waitPrintCount: { title: '待打印', values: 2, total: 0 }, // 待打印
        waitPickCount: { title: '待揽收', values: 3, total: 0 }, // 待揽收
        pickedCount: { title: '已揽收', values: 4, total: 0 }, // 已揽收
        cancelCount: { title: '撤销面单', values: 5, total: 0 }, // 撤销面单
      },
      statusCount: { // 物流订单分页数量统计
        total: 100, // 全部数量
        preArrangeCount: 12, // 待备货数量
        arrangedCount: 12, // 已备货数量
        prePostCount: 12, // 待发货数量
        postedCount: 13, // 已发货数量
        afterSaleCount: 14, // 售后数量
        selfPickupCount:0,  // 自提中数量
      },
      multipleSelection: [],
      multipleSelection3: [],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      breadcrumbConfig: {
        list: [
          {
            title: '订单管理',
            type: '#ff0000',
            path: '/'
          },
          {
            title: '物流订单',
            type: '1',
            path: ''
          }
        ]
      },
      itemListSplice: [],
      itemListAll: [],
      itemListAll1: [],
      orgCodevalue: '',
      purchaseFlag: '',
      searchFormVal: {

      },
      searchFormVal3: {

      },
      searchFormConfig: {
        formconfig: {
          labeWidth: 82, // 表单宽度
          itemList: [// 表单的list
            { type: 'input', prop: 'orderNo', placeholder: '请输入订单编号', label: '订单编号', size: 'small' },
            { type: 'input', prop: 'postUserInfo', placeholder: '请输入收货人信息', label: '收货人信息', size: 'small' },

            // {
            //   type: 'select', prop: 'payType', placeholder: '请选择支付方式', label: '支付方式', size: 'small',
            //   option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            // },
            {
              type: 'select', prop: 'platformId', placeholder: '请选择平台', label: '平台', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            // {
            //   type: 'select', prop: 'shopId', placeholder: '请选择店铺', label: '店铺', size: 'small',
            //   option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            // },
            {
              type: 'select', prop: 'applierId', placeholder: '请选择跟进客服', label: '跟进客服', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'logsticsExceptionReson', placeholder: '请选择物流状态', label: '物流异常', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            { type: 'input', prop: 'afterNo', placeholder: '请输入售后编号', label: '售后编号', size: 'small' },
            {
              type: 'select', prop: 'afterSaleStatus', placeholder: '请选择售后状态', label: '售后状态', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            }, {
              type: 'select', prop: 'afterSalesType', placeholder: '请选择售后原因', label: '售后原因', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            { type: 'daterange', prop: 'postTime', placeholder: '请选择日期', label: '发货时间', size: 'small' },
            {
              type: 'cascader', prop: 'orgCode', placeholder: '请选择公司部门', label: '公司部门', size: 'small', showAllLevels: false, isMultiple:true,
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2跟进客服' }]
            },
            { type: 'input', prop: 'logisticsNumber', placeholder: '请输入物流单号', label: '物流单号', size: 'small' },
            { type: 'daterange', prop: 'createdTime', placeholder: '请选择日期', label: '提交时间', size: 'small' },
            {
              type: 'select', prop: 'orderGenerateType', placeholder: '请选择订单分类', label: '订单分类', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'orderType', placeholder: '请选择订单类型', label: '订单类型', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'statusL', placeholder: '请选择状态', label: '状态', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'splitFlag', placeholder: '请选择', label: '是否拆单', size: 'small',
              option: [{ label: '是', value: '1' }, { label: '否', value: '0' }]
            },
            {
              type: 'select', prop: 'purchaseFlag', placeholder: '请选择内购价标记', label: '内购价标记', size: 'small', showAllLevels: false,
              option: [{ label: '使用内购价', value: '1' }, { label: '未使用', value: '0' }]
            },
             {
              type: 'select', prop: 'deliveryType', placeholder: '请选择配送方式', label: '配送方式', size: 'small', showAllLevels: false,
              option: [{ label: '邮寄', value: '1' }, { label: '自提', value: '2' }]
            }
          ],
          btnarry: [// 表单按钮
            { name: '查询', click: 'add', type: 'primary', plain: true, size: 'small' },
            { name: '重置', click: 'clrear', type: 'primary', plain: true, size: 'small' }
          ]
        },
        formData: { // 表单提交数据，
          orderNo: '',
          postUserInfo: '',
          platformId:'',
          applierId:'',
          logsticsExceptionReson:'',
          postTime:'',
          logisticsNumber: '',
          createdTime: '',
          orderType: '',
          statusL:'',
          splitFlag:'',
          purchaseFlag:'',
          orderGenerateType: '',
          deliveryType: '',
          checkbox: []// 注：如果类型是checkbox，必须foemData里边提前声明数组
        }
      },
      searchFormConfig1: {
        formconfig: {
          labeWidth: 82, // 表单宽度
          itemList: [// 表单的list
            { type: 'input', prop: 'orderNo', placeholder: '请输入订单编号', label: '订单编号', size: 'small' },
            { type: 'input', prop: 'postInfo', placeholder: '请输入收货人信息', label: '收货人信息', size: 'small' },
            // {
            //   type: 'select', prop: 'applierName', placeholder: '请选择跟进客服', label: '跟进客服', size: 'small',
            //   option: [{ label: '客服老六', value: 'key1' }, { label: '虚拟客服', value: '虚拟客服' }]
            // },
            { type: 'daterange', prop: 'createdTime', placeholder: '请选择日期', label: '提交时间', size: 'small' },
            { type: 'input', prop: 'remark', placeholder: '请输入留言/备注', label: '留言/备注', size: 'small' },
            {
              type: 'select', prop: 'logisticsCompanyCode', placeholder: '请选择物流公司', label: '物流公司', size: 'small',
              option: []
            },
          ],
          btnarry: [// 表单按钮
            { name: '查询', click: 'add', type: 'primary', plain: true, size: 'small' },
            { name: '重置', click: 'clrear', type: 'primary', plain: true, size: 'small' }
          ]
        },
        formData: { // 表单提交数据，
          orderIdList: [],
          orderNo: '',
          postInfo: '',
          createdTimeStart: '',
          createdTimeEnd: '',
          remark: '',
          logisticsCompanyCode: '',
          pageNo: 1,
          pageSize: 10,
          createdTime: null
        }
      },
      searchFormConfig2: {
        formconfig: {
          labeWidth: 82, // 表单宽度
          itemList: [// 表单的list
            { type: 'input', prop: 'orderNo', placeholder: '请输入生成批次', label: '生成批次', size: 'small' },
            { type: 'input', prop: 'orderNo', placeholder: '请输入订单编号', label: '订单编号', size: 'small' },
            { type: 'input', prop: 'postUserInfo', placeholder: '请输入收货人信息', label: '收货人信息', size: 'small' },
            // {
            //   type: 'select', prop: 'platformId', placeholder: '请选择平台', label: '平台', size: 'small',
            //   option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            // },
            {
              type: 'select', prop: 'orderGenerateType', placeholder: '请选择订单分类', label: '订单分类', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'cascader', prop: 'orgCode', placeholder: '请选择公司部门', label: '公司部门', size: 'small', showAllLevels: false,
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2跟进客服' }]
            },
            {
              type: 'select', prop: 'applierId', placeholder: '请选择跟进客服', label: '跟进客服', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            { type: 'daterange', prop: 'createdTime', placeholder: '请选择日期', label: '提交时间', size: 'small' },
          ],
          btnarry: [// 表单按钮
            { name: '查询', click: 'add', type: 'primary', plain: true, size: 'small' },
            { name: '重置', click: 'clrear', type: 'primary', plain: true, size: 'small' }
          ]
        },
        formData: { // 表单提交数据，
          "orderNo": "",
          "postInfo": "",
          "batchNo": "",
          "createdTime": null,
          "createdTimeStart": "",
          "createdTimeEnd": "",
          "remark": "",
          "logisticsCompanyCode": "",
          "pageNo": 1,
          "pageSize": 10
        }
      },
      searchFormConfig3: {
        formconfig: {
          labeWidth: 100, // 表单宽度
          itemList: [// 表单的list
            { type: 'input', prop: 'batchNo', placeholder: '请输入生成批次', label: '生成批次', size: 'small' },
            { type: 'input', prop: 'orderNo', placeholder: '请输入订单编号', label: '订单编号', size: 'small' },
            { type: 'input', prop: 'logisticsNo', placeholder: '请输入运单号', label: '运单号', size: 'small' },
            {
              type: 'select', prop: 'logisticsCompanyCode', placeholder: '请选择快递公司', label: '快递公司', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'multipleBagFlag', placeholder: '请选择是否子母件', label: '是否子母件', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            // {
            //   type: 'cascader', prop: 'status', placeholder: '请选择打印状态', label: '打印状态', size: 'small', showAllLevels: false,
            //   option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2跟进客服' }]
            // },
            { type: 'daterange', prop: 'printTime', placeholder: '请选择日期', label: '打印时间', size: 'small' },
            { type: 'daterange', prop: 'createdTime', placeholder: '请选择日期', label: '生成面单时间', size: 'small' },
            { type: 'daterange', prop: 'orderTime', placeholder: '请选择日期', label: '下单时间', size: 'small' },
            { type: 'daterange', prop: 'cancelTime', placeholder: '请选择日期', label: '撤销时间', size: 'small' },
          ],
          btnarry: [// 表单按钮
            { name: '查询', click: 'add', type: 'primary', plain: true, size: 'small' },
            { name: '重置', click: 'clrear', type: 'primary', plain: true, size: 'small' }
          ]
        },
        formData: { // 表单提交数据，
          // orderGenerateType: '',
          // checkbox: []// 注：如果类型是checkbox，必须foemData里边提前声明数组
          "batchNo": "",
          "orderNo": "",
          "logisticsNo": "",
          "logisticsCompanyCode": "",
          "multipleBagFlag": "",
          "printTime": null,
          "createdTime": null,
          "orderTime": null,
          "cancelTime": null,
          // "pageNo": 1,
          // "pageSize": 10
        }
      },
      activeName: 'goods',
      columnsDeriveRecord: [
        { label: '文件名', prop: 'fileName', minWidth: '230' },
        { label: '操作人', prop: 'userName', minWidth: '100' },
        { label: '导出时间', prop: 'createdDate', minWidth: '200' },
        {
          label: '操作', width: '100',
          render: (h, scope) => {
            return (
              <div>
                <el-link type='primary' size='mini' onClick={() => {
                  this.downloadlink(scope.row.excelUrl)
                }}>下载
                </el-link>
              </div>
            )
          }
        }
      ],
      columns: [],
      options: [
        {
          value: '1',
          label: '京东'
        },
        {
          value: '2',
          label: '德邦'
        }
      ],
      columns1: [
        { type: 'selection', fixed: 'left' },
        {
          label: '原单/母订单编号', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                <el-tooltip
                  class='item'
                  effect='dark'
                  content='单击复制'
                  placement='top'
                >
                  <p onClick={() => { this.copyInfo(scope.row) }} style='cursor:pointer' >{scope.row.orderNo}</p>
                </el-tooltip>
              </div>

            )
          }
        },
        {
          label: '子订单编号', width: '220', align: 'center',
          render: (h, scope) => {
            if (scope.row.type == 0) {
              return (
                <div >
                  <p>-</p>
                </div>
              )
            }
            return (
              <div style="height:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;">
                {
                  scope.row.subOrderList.map((item, index) => {
                    if (index < scope.row.subOrderList.length - 1) {
                      return (
                        <div style="border-bottom:1px solid #f0f0f0;height:100px;line-height:100px;width:120%;">{item.orderNo}</div>
                      )
                    } else {
                      return (
                        <div style="height:100px;line-height:100px;width:100%;">{item.orderNo}</div>
                      )
                    }

                  })
                }
              </div>
            )
          }


        },
        {
          label: '物流公司', width: '300', align: 'left',
          render: (h, scope) => {
            let c = ''
            return (
              <div>
                <el-select size='small' v-model={scope.row.logisticsCompanyCode} placeholder="请选择物流公司" onChange={($event) => { this.changeCompany($event, scope.$index) }}>
                  {
                    this.logisticsCompanyList.map(item => {
                      return (
                        <el-option key={item.value} value={item.value} label={item.label}></el-option>
                      )
                    })
                  }

                </el-select >

              </div >
            )
          }
        },
        {
          label: '寄件产品类型', width: '300', align: 'left',
          render: (h, scope) => {
            let c = ''
            return (
              <div>
                <el-select size='small' v-model={scope.row.logisticsProductType} placeholder="寄件产品类型" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}>
                  {
                    scope.row.productTypeList.map(item => {
                      return (
                        <el-option key={item.productTypeCode} value={item.productTypeCode} label={item.productTypeName}></el-option>
                      )
                    })
                  }

                </el-select >

              </div >
            )
          }
        },
        {
          label: '月结编码', width: '300', align: 'left',
          render: (h, scope) => {
            let c = ''
            return (
              <div>
                <el-select size='small' v-model={scope.row.logisticsCustomerCode} placeholder="月结编码" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}>
                  {
                    scope.row.monthCodeList.map(item => {
                      return (
                        <el-option key={item.value} value={item.value} label={item.label}></el-option>
                      )
                    })
                  }

                </el-select >

              </div >
            )
          }
        },
        {
          label: '商品名称', align: 'left', minWidth: '250',
          render: (h, scope) => {
            if (scope.row.type == 0) {
              return (
                <div >
                  <el-input size='small' type="textarea" v-model={scope.row.goodsName} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}></el-input>
                </div>
              )
            }
            return (
              <div style="height:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;">
                {
                  scope.row.subOrderList.map((item, index) => {
                    if (index < scope.row.subOrderList.length - 1) {
                      return (
                        <div style="border-bottom:1px solid #f0f0f0;height:100px;line-height:70px;width:120%;text-align:center;">
                          <el-input style='width:84%' size='small' rows="4" type="textarea" v-model={item.goodsName} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}></el-input>
                        </div>
                      )
                    } else {
                      return (
                        <div style="height:100px;line-height:70px;width:120%;text-align:center;">
                          <el-input style='width:84%' size='small' rows="4" type="textarea" v-model={item.goodsName} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}></el-input>
                        </div>
                      )
                    }

                  })
                }
              </div>
            )
          }

        },
        {
          label: '商品总数', prop: 'quantity', width: '110',
          render: (h, scope) => {
            if (scope.row.type == 0) {
              return (
                <div >
                  <p style="text-align:center;">{scope.row.quantity}</p>
                </div>
              )
            }
            return (
              <div style="height:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;">
                {
                  scope.row.subOrderList.map((item, index) => {
                    if (index < scope.row.subOrderList.length - 1) {
                      return (
                        <div style="border-bottom:1px solid #f0f0f0;height:100px;line-height:100px;width:120%;text-align:center;">
                          <p>{item.quantity}</p>
                        </div>
                      )
                    } else {
                      return (
                        <div style="height:100px;line-height:100px;width:120%;text-align:center;">
                          <p>{item.quantity}</p>
                        </div>
                      )
                    }

                  })
                }
              </div>
            )
          }
        },
        {
          label: '保价金额', align: 'left', minWidth: '140',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="number" v-model={scope.row.guaranteeMoney} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}></el-input>
              </div>
            )
          }
        },
        {
          label: '收货人', align: 'left', minWidth: '140',
          render: (h, scope) => {
            return (
              <div>
                <el-input type="text" size='small' v-model={scope.row.postName} style="margin-bottom:10px;" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}></el-input>
                <el-input type="text" size='small' v-model={scope.row.postContact} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}></el-input>
              </div>
            )
          }
        },
        {
          label: '收货地址', align: 'left', minWidth: '250',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="textarea" v-model={scope.row.postAddress} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}></el-input>
              </div>
            )
          }
        },
        {
          label: '寄件人信息', width: '300', align: 'left',
          render: (h, scope) => {
            let c = ''
            return (
              <div>
                <el-select size='small' v-model={scope.row.sendAddressId} placeholder="请选择寄件人信息" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}>
                  {
                    this.tableAddressList.map(item => {
                      return (
                        <el-option key={item.value} value={item.value} label={item.label}></el-option>
                      )
                    })
                  }

                </el-select >

              </div >
            )
          }
        },
        {
          label: '订单类型', align: 'left', minWidth: '180',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.orderTypeLabel}</p>
              </div>
            )
          }
        },
        {
          label: '金额', align: 'left', minWidth: '180',
          render: (h, scope) => {
            return (
              <div>
                <p>总价：￥{scope.row.totalAmount}</p>
                <p>已收：￥{scope.row.payedAmount}</p>
                <p>代收：￥{scope.row.collectionAmount}</p>
              </div>
            )
          }
        },
        { label: '提交时间', prop: 'createdTime', width: '180', align: 'left' },

        {
          label: '备注', prop: 'remarks', width: '180', align: 'left', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <p>客户留言:{scope.row.userRemarks ? scope.row.userRemarks : '-'}</p>
                <p>客服备注:{scope.row.remarks ? scope.row.remarks : '-'}</p>
              </div>
            )
          }
        },
        {
          label: '打印备注', prop: 'logisticsPrintRemark', width: '180', align: 'left', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="textarea" rows="4" v-model={scope.row.logisticsPrintRemark} maxlength="200" show-word-limit placeholder="请输入打印备注" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 1) }}></el-input>
              </div>
            )
          }
        },
      ],
      columns2: [
        { type: 'selection', fixed: 'left' },
        {
          label: '生成批次', prop: 'batchNo', width: '180', align: 'left',
        },
        {
          label: '失败原因', prop: 'printErrorReason', minWidth: '200', align: 'left',
          render: (h, scope) => {
            return (
              <div>
                <p title={scope.row.printErrorReason}>{scope.row.printErrorReason}</p>
              </div>
            )
          }
        },
        {
          label: '原单/母订单编号', prop: 'orderNo', width: '220', align: 'left',
        },
        {
          label: '子订单编号', width: '220', align: 'center',
          render: (h, scope) => {
            if (scope.row.type == 0) {
              return (
                <div >
                  <p>-</p>
                </div>
              )
            }
            return (
              <div style="height:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;">
                {
                  scope.row.subOrderList.map((item, index) => {
                    if (index < scope.row.subOrderList.length - 1) {
                      return (
                        <div style="border-bottom:1px solid #f0f0f0;height:100px;line-height:100px;width:120%;">{item.orderNo}</div>
                      )
                    } else {
                      return (
                        <div style="height:100px;line-height:100px;width:100%;">{item.orderNo}</div>
                      )
                    }

                  })
                }
              </div>
            )
          }


        },
        {
          label: '物流公司', width: '300', align: 'left',
          render: (h, scope) => {
            let c = ''
            return (
              <div>
                <el-select size='small' v-model={scope.row.logisticsCompanyCode} placeholder="请选择物流公司" onChange={($event) => { this.changeCompanyE($event, scope.$index) }}>
                  {
                    this.logisticsCompanyList.map(item => {
                      return (
                        <el-option key={item.value} value={item.value} label={item.label}></el-option>
                      )
                    })
                  }

                </el-select >

              </div >
            )
          }
        },
        {
          label: '寄件产品类型', width: '300', align: 'left',
          render: (h, scope) => {
            let c = ''
            return (
              <div>
                <el-select size='small' v-model={scope.row.logisticsProductType} placeholder="寄件产品类型" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}>
                  {
                    scope.row.productTypeList.map(item => {
                      return (
                        <el-option key={item.productTypeCode} value={item.productTypeCode} label={item.productTypeName}></el-option>
                      )
                    })
                  }

                </el-select >

              </div >
            )
          }
        },
        {
          label: '月结编码', width: '300', align: 'left',
          render: (h, scope) => {
            let c = ''
            return (
              <div>
                <el-select size='small' v-model={scope.row.logisticsCustomerCode} placeholder="月结编码" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}>
                  {
                    scope.row.monthCodeList.map(item => {
                      return (
                        <el-option key={item.value} value={item.value} label={item.label}></el-option>
                      )
                    })
                  }

                </el-select >

              </div >
            )
          }
        },
        {
          label: '商品名称', align: 'left', minWidth: '250',
          render: (h, scope) => {
            if (scope.row.type == 0) {
              return (
                <div >
                  <el-input size='small' rows="3" type="textarea" v-model={scope.row.goodsName} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}></el-input>
                </div>
              )
            }
            return (
              <div style="height:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;">
                {
                  scope.row.subOrderList.map((item, index) => {
                    if (index < scope.row.subOrderList.length - 1) {
                      return (
                        <div style="border-bottom:1px solid #f0f0f0;height:100px;line-height:70px;width:120%;text-align:center;">
                          <el-input rows="3" style='width:84%' size='small' type="textarea" v-model={item.goodsName} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}></el-input>
                        </div>
                      )
                    } else {
                      return (
                        <div style="height:100px;line-height:70px;width:120%;text-align:center;">
                          <el-input rows="3" style='width:84%' size='small' type="textarea" v-model={item.goodsName} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}></el-input>
                        </div>
                      )
                    }

                  })
                }
              </div>
            )

          }
        },
        {
          label: '商品总数', prop: 'quantity', width: '110',
          render: (h, scope) => {
            if (scope.row.type == 0) {
              return (
                <div >
                  <p style="text-align:center;">{scope.row.quantity}</p>
                </div>
              )
            }
            return (
              <div style="height:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;">
                {
                  scope.row.subOrderList.map((item, index) => {
                    if (index < scope.row.subOrderList.length - 1) {
                      return (
                        <div style="border-bottom:1px solid #f0f0f0;height:100px;line-height:100px;width:120%;text-align:center;">
                          <p>{item.quantity}</p>
                        </div>
                      )
                    } else {
                      return (
                        <div style="height:100px;line-height:100px;width:120%;text-align:center;">
                          <p>{item.quantity}</p>
                        </div>
                      )
                    }

                  })
                }
              </div>
            )
          }
        },
        {
          label: '保价金额', align: 'left', minWidth: '140',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="number" v-model={scope.row.guaranteeMoney} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}></el-input>
              </div>
            )
          }
        },
        {
          label: '收货人', align: 'left', minWidth: '140',
          render: (h, scope) => {
            return (
              <div>
                <el-input type="text" size='small' v-model={scope.row.postName} style="margin-bottom:10px;" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}></el-input>
                <el-input type="text" size='small' v-model={scope.row.postContact} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}></el-input>
              </div>
            )
          }
        },
        {
          label: '收货地址', align: 'left', minWidth: '250',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="textarea" v-model={scope.row.postAddress} onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}></el-input>
              </div>
            )
          }
        },
        {
          label: '寄件信息', width: '300', align: 'left',
          render: (h, scope) => {
            let c = ''
            return (
              <div>
                <el-select size='small' v-model={scope.row.sendAddressId} placeholder="请选择寄件信息" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}>
                  {
                    this.tableAddressList.map(item => {
                      return (
                        <el-option key={item.value} value={item.value} label={item.label}></el-option>
                      )
                    })
                  }

                </el-select >

              </div >
            )
          }
        },
        {
          label: '订单类型', align: 'left', minWidth: '180',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.orderTypeLabel}</p>
              </div>
            )
          }
        },
        {
          label: '金额', align: 'left', minWidth: '180',
          render: (h, scope) => {
            return (
              <div>
                <p>总价：￥{scope.row.totalAmount}</p>
                <p>已收：￥{scope.row.payedAmount}</p>
                <p>代收：￥{scope.row.collectionAmount}</p>
              </div>
            )
          }
        },
        { label: '提交时间', prop: 'createdTime', width: '180', align: 'left' },

        {
          label: '备注', prop: 'remarks', width: '180', align: 'left', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <p>客户留言:{scope.row.userRemarks ? scope.row.userRemarks : '-'}</p>
                <p>客服备注:{scope.row.remarks ? scope.row.remarks : '-'}</p>
              </div>
            )
          }
        },
        {
          label: '打印备注', prop: 'logisticsPrintRemark', width: '180', align: 'left', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="textarea" rows="4" v-model={scope.row.logisticsPrintRemark} maxlength="200" show-word-limit placeholder="请输入打印备注" onChange={($event) => { this.updateSplitOrder($event, scope.$index, 2) }}></el-input>
              </div >
            )
          }
        },
        {
          label: '操作', width: '100', align: 'left', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-button type="primary" plain size='small' onClick={() => { this.regenerateFn(scope.$index) }}>重新生成</el-button>
              </div>
            )
          }

        }
      ],
      columns3x: [
        { type: 'selection' },
        {
          label: '序号', prop: 'index',
          render: (h, scope) => {

            return (
              <div>
                {scope.$index + 1}

              </div >
            )
          }
        },
        {
          label: '生成批次', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                {scope.row.batchNo}
              </div>

            )
          }
        },
        {
          label: '是否子母件', prop: 'index', width: '150',
          render: (h, scope) => {
            let v = ''
            if (scope.row.multipleBagFlag == false) {
              v = '否'
            } else {
              v = '是'
            }
            return (
              <div>
                {v}

              </div >
            )
          }
        },

        {
          label: '订单编号', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.orderNo}</p>
              </div>

            )
          }
        },
        {
          label: '运单号', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                <el-tooltip
                  class='item'
                  effect='dark'
                  content='单击复制'
                  placement='top'
                >
                  <p onClick={() => { this.copyInfo3(scope.row.logisticsNo) }} style='cursor:pointer;color:#4168E7;' >{scope.row.logisticsNo}</p>
                </el-tooltip>
              </div>

            )
          }
        },
        {
          label: '物流公司', width: '100', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.logisticsCompanyLabel}

              </div >
            )
          }
        },
        {
          label: '寄件产品类型', width: '120', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.logisticsProductTypeLabel}

              </div >
            )
          }
        },
        {
          label: '状态', width: '100', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.statusLabel}

              </div >
            )
          }
        },
        {
          label: '收件人信息', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.postName ? scope.row.postName : '-'}  {scope.row.postContact ? scope.row.postContact : '-'}</p>
                <p>{scope.row.postAddress ? scope.row.postAddress : '-'}</p>

              </div>
            )
          }
        },
        {
          label: '寄件人信息', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.sendName ? scope.row.sendName : '-'}  {scope.row.sendContact ? scope.row.sendContact : '-'}</p>
                <p>{scope.row.sendAddress ? scope.row.sendAddress : '-'}</p>

              </div>
            )
          }
        },
        {
          label: '打印次数', align: 'left', minWidth: '100',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printCount || '0'}</p>
              </div>

            )
          }
        },
        {
          label: '打印时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '生成面单时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printCreateTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '下单时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.orderTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '打印备注', align: 'left', minWidth: '180', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="textarea" v-model={scope.row.logisticsPrintRemark}></el-input>
              </div>
            )
          }
        },
        {
          label: '寄件信息隐藏', align: 'center', minWidth: '250', fixed: 'right',
          render: (h, scope) => {
            let v = ''
            if (scope.row.hiddenSendInfoFlag) {
              v = '显示'
            } else {
              v = '隐藏'
            }
            return (
              <div style="text-align:center" >
                {v}
              </div>
            )
          }
        },
        {
          label: '操作', prop: 'submitDate', width: '120', align: 'center', fixed: 'right',
          render: (h, scope) => {
            let pp = '';
            if ((scope.row.multipleBagFlag && scope.row.orderNo.indexOf('-01') > -1) || !scope.row.multipleBagFlag) {
              if (scope.row.status == 2) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >预览打印</p>

                </div>
              } else if (scope.row.status == 4) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                </div>
              } else if (scope.row.status == 3) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >重新打印</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                </div>
              } else if (scope.row.status == 5) {
                pp = <p>-</p>
              } else {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >重新打印</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >预览打印</p>

                </div>
              }

            } else {
              pp = <p>-</p>
            }
            return (
              <div>{pp}</div>
            )
          }
        },
      ],
      columns3: [
        { type: 'selection' },
        {
          label: '序号', prop: 'index',
          render: (h, scope) => {

            return (
              <div>
                {scope.$index + 1}

              </div >
            )
          }
        },
        {
          label: '生成批次', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                {scope.row.batchNo}
              </div>

            )
          }
        },
        {
          label: '是否子母件', prop: 'index', width: '150',
          render: (h, scope) => {
            let v = ''
            if (scope.row.multipleBagFlag == false) {
              v = '否'
            } else {
              v = '是'
            }
            return (
              <div>
                {v}

              </div >
            )
          }
        },

        {
          label: '订单编号', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.orderNo}</p>
              </div>

            )
          }
        },
        {
          label: '运单号', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                <el-tooltip
                  class='item'
                  effect='dark'
                  content='单击复制'
                  placement='top'
                >
                  <p onClick={() => { this.copyInfo3(scope.row.logisticsNo) }} style='cursor:pointer;color:#4168E7;' >{scope.row.logisticsNo}</p>
                </el-tooltip>
              </div>

            )
          }
        },
        {
          label: '物流公司', width: '100', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.logisticsCompanyLabel}

              </div >
            )
          }
        },
        {
          label: '寄件产品类型', width: '120', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.logisticsProductTypeLabel}

              </div >
            )
          }
        },
        {
          label: '状态', width: '100', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.statusLabel}

              </div >
            )
          }
        },
        {
          label: '收件人信息', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.postName ? scope.row.postName : '-'}  {scope.row.postContact ? scope.row.postContact : '-'}</p>
                <p>{scope.row.postAddress ? scope.row.postAddress : '-'}</p>

              </div>
            )
          }
        },
        {
          label: '寄件人信息', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.sendName ? scope.row.sendName : '-'}  {scope.row.sendContact ? scope.row.sendContact : '-'}</p>
                <p>{scope.row.sendAddress ? scope.row.sendAddress : '-'}</p>

              </div>
            )
          }
        },
        {
          label: '打印次数', align: 'left', minWidth: '100',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printCount || '0'}</p>
              </div>

            )
          }
        },
        {
          label: '打印时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '生成面单时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printCreateTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '下单时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.orderTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '打印备注', align: 'left', minWidth: '180', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="textarea" v-model={scope.row.logisticsPrintRemark}></el-input>
              </div>
            )
          }
        },
        {
          label: '寄件信息隐藏', align: 'center', minWidth: '250', fixed: 'right',
          render: (h, scope) => {
            let v = ''
            if (scope.row.hiddenSendInfoFlag) {
              v = '显示'
            } else {
              v = '隐藏'
            }
            return (
              <div style="text-align:center" >
                {v}
              </div>
            )
          }
        },
        {
          label: '操作', prop: 'submitDate', width: '120', align: 'center', fixed: 'right',
          render: (h, scope) => {
            let pp = '';
            if ((scope.row.multipleBagFlag && scope.row.orderNo.indexOf('-01') > -1) || !scope.row.multipleBagFlag) {
              if (scope.row.status == 2) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >预览打印</p>

                </div>
              } else if (scope.row.status == 4) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                </div>
              } else if (scope.row.status == 3) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >重新打印</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                </div>
              } else if (scope.row.status == 5) {
                pp = <p>-</p>
              } else {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >重新打印</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >预览打印</p>

                </div>
              }

            } else {
              pp = <p>-</p>
            }
            return (
              <div>{pp}</div>
            )
          }
        },
      ],
      columns4: [
        { type: 'selection' },
        {
          label: '序号', prop: 'index',
          render: (h, scope) => {

            return (
              <div>
                {scope.$index + 1}

              </div >
            )
          }
        },
        {
          label: '生成批次', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                {scope.row.batchNo}
              </div>

            )
          }
        },
        {
          label: '是否子母件', prop: 'index', width: '150',
          render: (h, scope) => {
            let v = ''
            if (scope.row.multipleBagFlag == false) {
              v = '否'
            } else {
              v = '是'
            }
            return (
              <div>
                {v}

              </div >
            )
          }
        },

        {
          label: '订单编号', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.orderNo}</p>
              </div>

            )
          }
        },
        {
          label: '运单号', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                <el-tooltip
                  class='item'
                  effect='dark'
                  content='单击复制'
                  placement='top'
                >
                  <p onClick={() => { this.copyInfo3(scope.row.logisticsNo) }} style='cursor:pointer;color:#4168E7;' >{scope.row.logisticsNo}</p>
                </el-tooltip>
              </div>

            )
          }
        },
        {
          label: '物流公司', width: '100', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.logisticsCompanyLabel}

              </div >
            )
          }
        },
        {
          label: '寄件产品类型', width: '120', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.logisticsProductTypeLabel}

              </div >
            )
          }
        },
        {
          label: '收件人信息', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.postName ? scope.row.postName : '-'}  {scope.row.postContact ? scope.row.postContact : '-'}</p>
                <p>{scope.row.postAddress ? scope.row.postAddress : '-'}</p>

              </div>
            )
          }
        },
        {
          label: '寄件人信息', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.sendName ? scope.row.sendName : '-'}  {scope.row.sendContact ? scope.row.sendContact : '-'}</p>
                <p>{scope.row.sendAddress ? scope.row.sendAddress : '-'}</p>

              </div>
            )
          }
        },
        {
          label: '打印次数', align: 'left', minWidth: '100',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printCount || '0'}</p>
              </div>

            )
          }
        },
        {
          label: '打印时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printTime || '-'}</p>
              </div>

            )
          }
        },

        {
          label: '生成面单时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printCreateTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '下单时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.orderTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '打印备注', align: 'left', minWidth: '180', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="textarea" v-model={scope.row.logisticsPrintRemark}></el-input>
              </div>
            )
          }
        },
        {
          label: '寄件信息隐藏', align: 'center', minWidth: '250', fixed: 'right',
          render: (h, scope) => {
            let v = ''
            if (scope.row.hiddenSendInfoFlag) {
              v = '显示'
            } else {
              v = '隐藏'
            }
            return (
              <div style="text-align:center" >
                {v}
              </div>
            )
          }
        },
        {
          label: '操作', prop: 'submitDate', width: '120', align: 'center', fixed: 'right',
          render: (h, scope) => {
            let pp = '';
            if ((scope.row.multipleBagFlag && scope.row.orderNo.indexOf('-01') > -1) || !scope.row.multipleBagFlag) {
              if (scope.row.status == 2) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >预览打印</p>

                </div>
              } else if (scope.row.status == 4) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                </div>
              } else if (scope.row.status == 3) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >重新打印</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                </div>
              } else if (scope.row.status == 5) {
                pp = <p>-</p>
              } else {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >重新打印</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >预览打印</p>

                </div>
              }

            } else {
              pp = <p>-</p>
            }
            return (
              <div>{pp}</div>
            )
          }
        },
      ],
      columns5: [
        { type: 'selection' },
        {
          label: '序号', prop: 'index',
          render: (h, scope) => {

            return (
              <div>
                {scope.$index + 1}

              </div >
            )
          }
        },
        {
          label: '生成批次', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                {scope.row.batchNo}
              </div>

            )
          }
        },
        {
          label: '是否子母件', prop: 'index', width: '150',
          render: (h, scope) => {
            let v = ''
            if (scope.row.multipleBagFlag == false) {
              v = '否'
            } else {
              v = '是'
            }
            return (
              <div>
                {v}

              </div >
            )
          }
        },

        {
          label: '订单编号', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.orderNo}</p>
              </div>

            )
          }
        },
        {
          label: '运单号', width: '220', align: 'left',
          render: (h, scope) => {
            return (

              <div >
                <el-tooltip
                  class='item'
                  effect='dark'
                  content='单击复制'
                  placement='top'
                >
                  <p onClick={() => { this.copyInfo3(scope.row.logisticsNo) }} style='cursor:pointer;color:#4168E7;' >{scope.row.logisticsNo}</p>
                </el-tooltip>
              </div>

            )
          }
        },
        {
          label: '物流公司', width: '100', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.logisticsCompanyLabel}

              </div >
            )
          }
        },
        {
          label: '寄件产品类型', width: '120', align: 'left',
          render: (h, scope) => {

            return (
              <div>
                {scope.row.logisticsProductTypeLabel}

              </div >
            )
          }
        },
        {
          label: '收件人信息', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.postName ? scope.row.postName : '-'}  {scope.row.postContact ? scope.row.postContact : '-'}</p>
                <p>{scope.row.postAddress ? scope.row.postAddress : '-'}</p>

              </div>
            )
          }
        },
        {
          label: '寄件人信息', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.sendName ? scope.row.sendName : '-'}  {scope.row.sendContact ? scope.row.sendContact : '-'}</p>
                <p>{scope.row.sendAddress ? scope.row.sendAddress : '-'}</p>

              </div>
            )
          }
        },
        {
          label: '撤销时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.cancelTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '生成面单时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.printCreateTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '下单时间', align: 'left', minWidth: '300',
          render: (h, scope) => {
            return (

              <div >
                <p>{scope.row.orderTime || '-'}</p>
              </div>

            )
          }
        },
        {
          label: '打印备注', align: 'left', minWidth: '180', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-input size='small' type="textarea" v-model={scope.row.logisticsPrintRemark}></el-input>
              </div>
            )
          }
        },
        {
          label: '寄件信息隐藏', align: 'center', minWidth: '250', fixed: 'right',
          render: (h, scope) => {
            let v = ''
            if (scope.row.hiddenSendInfoFlag) {
              v = '显示'
            } else {
              v = '隐藏'
            }
            return (
              <div style="text-align:center" >
                {v}
              </div>
            )
          }
        },
        {
          label: '操作', prop: 'submitDate', width: '120', align: 'center', fixed: 'right',
          render: (h, scope) => {
            let pp = '';
            if ((scope.row.multipleBagFlag && scope.row.orderNo.indexOf('-01') > -1) || !scope.row.multipleBagFlag) {
              if (scope.row.status == 2) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >预览打印</p>

                </div>
              } else if (scope.row.status == 4) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                </div>
              } else if (scope.row.status == 3) {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >重新打印</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                </div>
              } else if (scope.row.status == 5) {
                pp = <p>-</p>
              } else {
                pp = <div style="display:flex;flex-wrap:wrap">
                  <p class={scope.row.orderGenerateType == 1 ? 'info' : 'hide-content info'} style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.cOrder(scope.row, scope.$index) }} >撤销面单</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >重新打印</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printView(scope.row, scope.$index, 'single') }} >预览</p>
                  <p style="color:#0b7df3;text-align:center;cursor:pointer;margin-right:10px;width:100%;" onClick={() => { this.printM(scope.row, scope.$index, 'single') }} >预览打印</p>

                </div>
              }

            } else {
              pp = <p>-</p>
            }
            return (
              <div>{pp}</div>
            )
          }
        },
      ],
      // 公共  column
      columnCommon: [
        {
          type: 'selection',
          render: (h, scope) => {
            return (
              <div class={scope.row.splitType == 0 ? 'info' : 'hide-content info'}>
                <el-checkbox v-model={scope.row.isSelected} onChange={() => { this.changeSelect(scope.row, scope.$index) }}></el-checkbox>
              </div >
            )
          }
        },
        {
          label: '订单编号', width: '300', align: 'left', fixed: 'left',
          render: (h, scope) => {
            let d = ''
            if (scope.row.isShow) {
              d = <div onClick={() => { this.splitOrder(scope.row, scope.$index) }} style="width: 84px;height: 20px;background: #E3EDFF;border-radius: 4px;font-size: 14px;font-family: PingFang SC;font-weight: 400;line-height: 22px;color: #4168E7;opacity: 1;text-align:center">
                拆单订单<i class="el-icon-arrow-up"></i>
              </div>
            } else {
              d = <div onClick={() => { this.splitOrder(scope.row, scope.$index) }} style="width: 84px;height: 20px;background: #E3EDFF;border-radius: 4px;font-size: 14px;font-family: PingFang SC;font-weight: 400;line-height: 22px;color: #4168E7;opacity: 1;text-align:center">
                拆单订单<i class="el-icon-arrow-down"></i>
              </div>
            }
            let p = ''
            if (scope.row.splitType == 0) {
              p = <p onClick={() => { this.copyInfo(scope.row) }} style='cursor:pointer;' >{scope.row.orderNo}</p>
            } else if (scope.row.splitType == 1) {
              p = <p onClick={() => { this.copyInfo(scope.row) }} style='cursor:pointer;margin-left:10px;' >{scope.row.orderNo}</p>
            } else {
              p = <p onClick={() => { this.copyInfo(scope.row) }} style='cursor:pointer;margin-left:50px;' >{scope.row.orderNo}</p>
            }
            let currentStatus = this.currentStatus
            return (
              <div >
                <div class={currentStatus !== 5 ? 'info' : 'hide-content info'}>
                  <div style="display:flex" class={scope.row.splitType == 1 ? 'info' : 'hide-content info'}>
                    <div style="width: 40px;height: 20px;background: #DFF7EC;opacity: 1;border-radius: 4px;font-size: 14px;font-family: PingFang SC;font-weight: 400;line-height: 20px;color: #12AB62;text-align:center;margin-top:2px" class={scope.row.splitType == 1 ? 'info' : 'hide-content info'}>母单</div>
                    <div>
                      <el-tooltip
                        class='item'
                        effect='dark'
                        content='单击复制'
                        placement='top'
                      >
                        {p}
                      </el-tooltip>


                    </div>

                  </div>

                  <div style="display:flex;justify-content:space-between;">

                    <div class={scope.row.splitType == 0 || scope.row.splitType == 2 ? 'info' : 'hide-content info'}>
                      <el-tooltip
                        class='item'
                        effect='dark'
                        content='单击复制'
                        placement='top'
                      >
                        {p}
                      </el-tooltip>


                    </div>

                    <div class={scope.row.splitType == 0 && (scope.row.splitOrderList && scope.row.splitOrderList.length > 0) ? 'info' : 'hide-content info'}>
                      {d}
                    </div >
                  </div >
                  <p class={scope.row.platformOrderNo && scope.row.splitType == 0 ? 'info' : 'hide-content info'}>关联订单：{scope.row.platformOrderNo}</p>
                </div>
                <div class={currentStatus == 5 ? 'info' : 'hide-content info'}>{scope.row.orderNo}</div>
              </div>

            )
          }
        },
        {
          label: '收货人', align: 'left', minWidth: '140',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.postName ? scope.row.postName : '-'}</p>
                <p>{scope.row.postContact ? scope.row.postContact : '-'}</p>

              </div>
            )
          }
        },
        {
          label: '收货地址', align: 'left', minWidth: '250',
          render: (h, scope) => {
            const isSelfPickup = scope.row.deliveryType == 2
            let address = '-'
            if (isSelfPickup) {
              const storeInfo = scope.row.storeInfoJson ? JSON.parse(scope.row.storeInfoJson) : {}
              address = storeInfo.storeAddress || '-'
            } else {
              address = scope.row.postAddress ? scope.row.postAddress : '-'
            }
            const icon = <span style='display:inline-block; border:1px solid #409EFF;color:#409EFF;line-height:1;padding:3px;margin-left:4px;'>自提</span>
            return (
              <div>
                <p>{address}{isSelfPickup ? icon : null}</p>
              </div>
            )
          }
        },
        {
          label: '订单类型', align: 'left', minWidth: '180',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.orderTypeLabel}</p>
              </div>
            )
          }
        },
        {
          label: '商品名称', align: 'left', minWidth: '250', sortable: 'custom',
          sortMethod: (a, b) => {
            console.log(a, b)
            // return a.goodsName.localeCompare(b.goodsName)
          },
          render: (h, scope) => {
            return (
              <div>
                <p title={scope.row.goodsName}>{scope.row.goodsName}</p>
              </div>
            )
          }
        },
        { label: '数量', prop: 'quantity' },
        { label: '公司部门', prop: 'orgName', minWidth: '180', align: 'left' },
        { label: '订单分类', prop: 'orderGenerateTypeLabel', minWidth: '180', align: 'left' },
        { label: '跟进客服', prop: 'applierName', minWidth: '150', align: 'left' }
      ],
      // 全部  column
      columnAll: [
        // { label: '支付方式', prop: 'payTypeLabel', width: '170', align: 'left' },
        {
          label: '金额', align: 'left', minWidth: '150',
          render: (h, scope) => {
            return (
              <div>
                <p>总价:￥{scope.row.totalAmount ? scope.row.totalAmount : '0'}</p>
                <p>已收:￥{scope.row.receivedAmount ? scope.row.receivedAmount : '0'}</p>
                <p>代收:￥{scope.row.collectionAmount ? scope.row.collectionAmount : '0'}</p>
              </div>
            )
          }
        },
        {
          label: '状态', align: 'left',
          render: (h, scope) => {
            return (
              <div>
                <p class={scope.row.status === 1 ? 'danger' : 'hide-content' ||
                  scope.row.status === 2 ? 'warning' : 'hide-content' ||
                    scope.row.status === 3 ? 'primary' : 'hide-content' ||
                      scope.row.status === 4 ? 'success' : 'hide-content' ||
                        scope.row.status === 5 ? 'info' : 'hide-content'}>{scope.row.statusLabel ? scope.row.statusLabel : '-'}</p>
              </div>
            )
          }
        },
        { label: '提交时间', prop: 'submitDate', width: '180', align: 'left' },
        { label: '配送方式', prop: 'deliveryTypeLabel', width: '100', align: 'left' },
        {
          label: '备注/留言', align: 'left', minWidth: '250', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <p>客户留言:{scope.row.userRemarks ? scope.row.userRemarks : '-'}</p>
                <p>客服备注:{scope.row.remarks ? scope.row.remarks : '-'}</p>
              </div>
            )
          }
        },
        {
          label: '操作', width: '140', fixed: 'right',
          render: (h, scope) => {
            let pp = ''
            if (scope.row.hasTask === 1 && scope.row.splitType === 0) {
              pp = <el-link type='primary' size='mini' onClick={() => { this.showDialog('审核流程', '640px', 'shenheStep', scope.row, scope.$index) }}>进度</el-link>
            }
            let ll = ''
            if (scope.row.splitType === 0) {
              ll = <el-link type='primary' size='mini' onClick={() => {
                this.toOtherPages('orderDetails', scope.row, 'logistics')
              }}>查看
              </el-link>
            } else {
              ll = '--'
            }
            return (
              <div>
                {ll}
                {/* <el-link type='primary' size='mini' onClick={() => { this.showDialog('审核流程', '640px', 'shenheStep', scope.row, scope.$index) }}>进度</el-link> */}
                {pp}
              </div>
            )
          }
        }
      ],
      // 待备货 column + 已备货 column +  待发货 column + 已发货 column
      columnMiddle: [
        // { label: '支付方式', prop: 'payTypeLabel', minWidth: '150', align: 'left' },
        {
          label: '金额', align: 'left', minWidth: '160',
          render: (h, scope) => {
            return (
              <div>
                <p>总价:￥{scope.row.totalAmount ? scope.row.totalAmount : '0'}</p>
                <p>已收:￥{scope.row.receivedAmount ? scope.row.receivedAmount : '0'}</p>
                <p>代收:￥{scope.row.collectionAmount ? scope.row.collectionAmount : '0'}</p>
              </div>
            )
          }
        },
        {
          label: '状态', align: 'left', minWidth: '100',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.statusLabel ? scope.row.statusLabel : '-'}</p>
              </div>
            )
          }
        },
        { label: '提交时间', prop: 'submitDate', minWidth: '180', align: 'left' },
        { label: '配送方式', prop: 'deliveryTypeLabel', width: '100', align: 'left' },
        {
          label: '备注/留言', minWidth: '250', align: 'left', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <p>客户留言:{scope.row.userRemarks ? scope.row.userRemarks : '-'}</p>
                <p>客服备注:{scope.row.remarks ? scope.row.remarks : '-'}</p>
              </div>
            )
          }
        },
      ],
      // 售后件 column
      columnAfterSale: [
        {
          label: '金额', align: 'left', minWidth: '150',
          render: (h, scope) => {
            return (
              <div>
                <p>总价:￥{scope.row.totalAmount ? scope.row.totalAmount : '0'}</p>
                <p>已收:￥{scope.row.receivedAmount ? scope.row.receivedAmount : '0'}</p>
                <p>代收:￥{scope.row.collectionAmount ? scope.row.collectionAmount : '0'}</p>
              </div>
            )
          }
        },
        { label: '收货状态', minWidth: '120', prop: 'afterSaleType', align: 'left' },
        {
          label: '操作', minWidth: '180', fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-link type='primary' size='mini' onClick={() => {
                  this.toOtherPages('afterSaleRecordList', scope.row, 'afterSaleRecordList')
                }}>售后记录
                </el-link>
              </div>
            )
          }
        }
      ],
      tableList: [],
      tableListx: [],
      pageSizeDan: 10,
      currentPageDan: 1,
      totalNumDan: 0,
      logisticsCompanyList: [],
      isExpand: true,
      optionCodeType: 'add',
      qSplitList: [],
      splitOrderId: null,
      sType: '',
      productTypeList: [],
      monthCodeList: [],
      ebillErrorOrderList: [],
      totalNumFailDan: 0,
      currentPageFailDan: 1,
      pageSizeFailDan: 10,
      ebillErrorCount: 0,
      showTable: false,
      batchLogistics: {
        logisticsCompanyCode: null,
        logisticsCustomerCode: null,
        logisticsProductType: null,
        sendAddressId: null,
        logisticsPrintRemark: ''
      },
      batchRules: {
        logisticsCompanyCode: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        logisticsProductType: [
          { required: true, message: '请选择寄件产品类型', trigger: 'change' }
        ],
        sendAddressId: [
          { required: true, message: '请选择寄件人信息', trigger: 'change' }
        ]
      },
      printOrderList: [],
      totalNum3: 0,
      pageNo3: 1,
      pageSize3: 10,
      cOrderId: '',
      cOrderId1: '',
      templateCode: '',
      isPreview: false,
      isPreview1: false,
      printData: [],
      pIds: [],
      pType: '',
      sId: '',
      isFailO: false,
      isDB: false,
      isNum: 0
    }
  },
  watch: {
    platformDataList(val, oldVal) { // 平台
      val.forEach(item => {
        item.label = item.name
        item.value = item.id
      })
      const index = this.searchFormConfig.formconfig.itemList.findIndex(e => {
        return e.label === '平台'
      })
      this.searchFormConfig.formconfig.itemList[index].option = val
    },
    orgCodeList(val, oldVal) {
      val.forEach(item => {
        item.label = item.reallyName
        item.value = item.id
      })
      const index = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '公司部门' })
      this.searchFormConfig.formconfig.itemList[index].option = val
    },
    /*
    shopDataList (val, oldVal) { // 店铺
      console.log(val)
      val.forEach(item => {
        item.label = item.name
        item.value = item.id
      })
      const index = this.searchFormConfig.formconfig.itemList.findIndex(e => {
        return e.label === '店铺'
      })
      this.searchFormConfig.formconfig.itemList[index].option = val
    },
    */
    salesAuthority(val, oldVal) { // 跟进客服
      val.forEach(item => {
        item.label = item.reallyName
        item.value = item.id
      })
      const index = this.searchFormConfig.formconfig.itemList.findIndex(e => {
        return e.label === '跟进客服'
      })
      this.searchFormConfig.formconfig.itemList[index].option = val
    },
    dictionaries: {
      handler(newVal, oldVal) {
        setTimeout(_ => {
          // this.setSearchDictionaries('状态', 'order_main_subset_status')
          // this.setSearchDictionaries('支付方式', 'order_pay_type')
          this.setSearchDictionaries('物流异常', 'logistics_exception_reason')
          this.setSearchDictionaries('订单分类', 'order_generate_type')
          this.setSearchDictionaries('订单类型', 'order_main_type')
          // 售后件
          if (this.currentStatus === this.logisticsStatus.afterSale.values) {
            this.setSearchDictionaries('售后状态', 'after_sale_status')
            this.setSearchDictionaries('售后原因', 'after_sale_reason')
          }
        }, 100)
      },
      deep: true // 为true，表示深度监听
    }
  },
  created() {
    // console.log(location.protocol)
    this.initSearchList() // 初始化，搜索需要的列表数据
    // 初始表格
    this.columns = this.columnCommon.concat(this.columnAll)
    this.itemListAll = [...this.searchFormConfig.formconfig.itemList]
    this.itemListAll1 = [...this.searchFormConfig3.formconfig.itemList]
    const tempItemList = this.searchFormConfig.formconfig.itemList
    tempItemList.splice(5, 3)
    this.itemListSplice = [...tempItemList]
    this.getLogisticsCompany()
    this.getLogisticsCompanyList()
    this.getEbillErrorCount()
    this.getButtonTreeDto()
    let list = []
    const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '状态' })
    list[0] = {
      value: 1,
      label: '发货前'
    }
    list[1] = {
      value: 2,
      label: '已发货'
    }
    list[2] = {
      value: 3,
      label: '已完成'
    }
    this.searchFormConfig.formconfig.itemList[payIndex].option = list
  },
  mounted() {
    // window.addEventListener('scroll', this.scrollToTop,true)
    this.$nextTick(() => {
      setTimeout(_ => {
        // 获取本地缓存字典
        const sessionDictionaries = JSON.parse(sessionStorage.getItem('dictionaries'))
        if (sessionDictionaries) {
          this.sessionDictionaries = sessionDictionaries
        }
        this.fetchData('init')
      }, 1000)
    })
  },
  beforeRouteEnter(to, from, next) {

    next(vm => {
      vm.fetchData('init')
    })
  },
  methods: {
    //批量预览打印面单
    lotsPrintOrder() {
      this.pType = 'lots'
      if (!this.searchFormConfig3.formData.logisticsCompanyCode) {
        this.$message.error('请选择物流公司')
      } else {
        this.isExportPrint = true
      }
      if (this.searchFormConfig3.formData.logisticsCompanyCode == 'DB') {
        this.isDB = true
        if (this.multipleSelection3.length == 0) {
          let arr = []
          this.printOrderList.forEach(item => {
            arr.push(item.splitOrderId)
          })
          let data = { logisticID: arr }
          this.axios.post('/neworder/order/logistics/getPrintData', data)
            .then(res => {
              console.log('打印信息==', res)
              if (res.code == 0) {
                this.printData = res.data
              }
            })
        } else {
          let arr = []
          this.multipleSelection3.forEach(item => {
            arr.push(item.splitOrderId)
          })
          let data = { logisticID: arr }
          this.axios.post('/neworder/order/logistics/getPrintData', data)
            .then(res => {
              console.log('打印信息==', res)
              if (res.code == 0) {
                this.printData = res.data

              }
            })
        }

      } else {
        this.isDB = false
      }
    },
    lotPrintSubmit() {
      if (this.searchFormConfig3.formData.logisticsCompanyCode == 'DB') {
        let ids = []
        if (this.multipleSelection3.length == 0) {
          let arr = []
          this.printOrderList.forEach(item => {
            arr.push(item.splitOrderId)
          })
          ids = arr
        } else {
          let arr = []
          this.multipleSelection3.forEach(item => {
            arr.push(item.splitOrderId)
          })
          ids = arr
        }

        let data = {
          orderLogisticsSplitIds: ids
        }
        this.axios.post('/neworder/order/logistics/changeDeBangLiver', data)
          .then(res => {
            if (res.code == 0) {

            }
          })
        printTest(this.printData)
      } else {
        this.isPrintM = true
        this.axios.get('/neworder/orderLogisticsSplit/getPrintTemplate?companyCode=' + this.searchFormConfig3.formData.logisticsCompanyCode)
          .then(res => {
            if (res.code == 0) {
              this.printModels = res.data
            }
          })
      }
    },
    //导出
    exportPrintOrder() {
      let params = {
        pageNo: this.pageNo3,
        pageSize: this.pageSize3
      }
      params = Object.assign(params, this.searchFormConfig3.formData)
      if (params.orderTime) {
        params.orderTimeStart = params.orderTime[0]
        params.orderTimeEnd = params.orderTime[1]
      }
      if (params.createdTime) {
        params.createdTimeStart = params.createdTime[0]
        params.createdTimeEnd = params.createdTime[1]
      }
      if (params.printTime) {
        params.printTimeStart = params.printTime[0]
        params.printTimeEnd = params.printTime[1]
      }
      params.status = this.currentStatus1
      this.axios.post('/neworder/orderLogisticsSplit/export', params).then((res) => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message.success('操作成功！')

        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.log(err)
        // this.btnLoading = false
      })
    },
    //导出拣货单
    exportPickOrder() {
      let params = {

      }

      params.status = this.currentStatus1
      this.axios.post('/neworder/orderLogisticsSplit/pickExport', params).then((res) => {
        if (res.code == 0) {
          this.isPreview1 = true
          this.downloadlink(res.data)
          this.$message.success('操作成功！')

        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.log(err)
        // this.btnLoading = false
      })
    },
    handleSortChange(val) {
      console.log(val)
      let ascType = null
      if (val == 'ascending') {
        ascType = '1'
      } else {
        ascType = '0'
      }
      let arr = []
      let obj = {
        sortType: '1',
        ascType: ascType,
      }
      arr.push(obj)
      this.searchFormVal.sortFlags = arr
      this.fetchData('search')
    },
    clearSelection() {
      let ref = this.isBatch == 1 ? 'sctable' : 'sbtable'
      this.$refs[ref].clearSelection()
    },
    changeCompany(e, index) {
      this.tableListx[index].logisticsProductType = null
      this.tableListx[index].logisticsCustomerCode = null
      console.log(e, index)
      this.axios.get('/neworder/logisticsCompany/getProductType?companyCode=' + e)
        .then(res1 => {
          if (res1.code == 0) {
            this.tableListx[index].productTypeList = res1.data || []
          }
        })
      this.axios.get('/neworder/logisticsCompanyAccount/listByLogisticsCompany?companyCode=' + e)
        .then(res2 => {
          if (res2.code == 0) {
            let list = res2.data.map(itm => {
              return {
                value: itm,
                label: itm
              }
            })
            this.tableListx[index].monthCodeList = list;
          }
        })
      this.updateSplitOrder(e, index, 1)
    },
    changeCompanyE(e, index) {
      this.ebillErrorOrderList[index].logisticsProductType = null
      this.ebillErrorOrderList[index].logisticsCustomerCode = null
      console.log(e, index)
      this.axios.get('/neworder/logisticsCompany/getProductType?companyCode=' + e)
        .then(res1 => {
          if (res1.code == 0) {
            this.ebillErrorOrderList[index].productTypeList = res1.data || []
          }
        })
      this.axios.get('/neworder/logisticsCompanyAccount/listByLogisticsCompany?companyCode=' + e)
        .then(res2 => {
          if (res2.code == 0) {
            let list = res2.data.map(itm => {
              return {
                value: itm,
                label: itm
              }
            })
            this.ebillErrorOrderList[index].monthCodeList = list;
          }
        })
      this.updateSplitOrder(e, index, 2)
    },
    printView(row) {
      this.isPreview = true
      if (row.logisticsCompanyCode == 'DB') {
        this.pType = 'single'
        this.isDB = true
        let arr = []
        arr.push(row.splitOrderId)
        let data = { logisticID: arr }
        this.axios.post('/neworder/order/logistics/getPrintData', data)
          .then(res => {
            console.log('打印信息==', res)
            if (res.code == 0) {
              this.printData = res.data
            }
          })
      } else {
        this.isDB = false
        this.axios.post('/neworder/orderLogisticsSplit/previewPrint', {
          orderId: row.id
        })
          .then(res => {
            if (res.code == 0) {
              this.pdfUrl = res.data
            }
          })
      }

    },
    selectPrintModel(row, index) {
      this.templateCode = row.code
      this.printModelIndex = index
    },
    printModelData() {
      this.pIds = []
      if (this.pType == 'single') {
        // let ids = []
        this.pIds.push(this.cOrderId)
      } else {

        if (this.multipleSelection3.length == 0) {
          let arr = []
          this.printOrderList.forEach(item => {
            arr.push(item.id)
          })
          this.pIds = arr
        } else {
          let arr = []
          this.multipleSelection3.forEach(item => {
            arr.push(item.id)
          })
          this.pIds = arr
        }
      }
      this.axios.post('/neworder/orderLogisticsSplit/print', {
        templateCode: this.templateCode,
        orderIdList: this.pIds
      }).then(res => {
        if (res.code == 0) {
          this.isPrintM = false
          this.isPreview = true
          this.pdfUrl = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    printM(row, index, type) {
      if (row.logisticsCompanyCode == "DB") {
        this.printOrderDialog = true;//printData
        let arr = []
        arr.push(row.splitOrderId)
        let data = { logisticID: arr }
        this.axios.post('/neworder/order/logistics/getPrintData', data)
          .then(res => {
            console.log('打印信息==', res)
            if (res.code == 0) {
              this.printData = res.data
            }
          })
        this.sId = row.splitOrderId
        return
      }
      this.pType = type
      this.isPrintM = true
      this.printModelIndex = 0
      this.cOrderId = row.id
      this.axios.get('/neworder/orderLogisticsSplit/getPrintTemplate?companyCode=' + row.logisticsCompanyCode)
        .then(res => {
          if (res.code == 0) {
            this.printModels = res.data
            this.templateCode = this.printModels[0].code
          }
        })
    },
    batchLogisticsFn() {
      this.$refs['logisticsForm'].validate((valid) => {
        console.log(valid, '验证')
        if (valid) {
          let data = {}
          for (let i in this.batchLogistics) {
            data[i] = this.batchLogistics[i]
            this.waitOrderList.forEach((item, index) => {
              item[i] = this.batchLogistics[i]
            })
          }
          this.isSelectLogistics = false;
          data.idList = this.waitOrderList.map(item => {
            return {
              orderId: item.id,
              type: item.type
            }
          })
          this.batchUpdateSplitOrder(data)
        } else {
          console.log('error submit!!');
          this.$message.error('请确认所选订单信息填写完毕！');
          return false;
        }
      });
    },
    batchUpdateSplitOrder(data) {
      this.axios.post('/neworder/orderLogisticsSplit/batchUpdateSplitOrder', data)
        .then(res => {
          console.log('批量更新订单状态', res)
          if (res.code == 0) {
            if (this.isBatch == 2) {
              this.createEbillBatch()
              this.dialogClickFailDan('search')
              this.isFailO = true
            } else {
              this.dialogClickDan('search')
            }

          }

        })
    },
    updateSplitOrder(e, index, type) {
      // console.log('失焦参数====' ,this.tableListx[index])
      let data = type == 1 ? this.tableListx[index] : this.ebillErrorOrderList[index]
      console.log('失焦参数====', data, type)
      let params = {
        id: data.id,
        type: data.type,
        logisticsCompanyCode: data.logisticsCompanyCode,
        logisticsCustomerCode: data.logisticsCustomerCode,
        logisticsProductType: data.logisticsProductType,
        guaranteeMoney: data.guaranteeMoney,
        postName: data.postName,
        postContact: data.postContact,
        postAddress: data.postAddress,
        sendAddressId: data.sendAddressId,
        logisticsPrintRemark: data.logisticsPrintRemark
      }
      if (data.type == 1) {
        params.subOrderList = data.subOrderList.map(item => {
          return {
            id: item.id,
            goodsName: item.goodsName
          }
        })
      } else {
        params.goodsName = data.goodsName
        // params.subOrderList = []
        // let obj = {
        //   id: data.id,
        //   goodsName: data.goodsName
        // }
        // params.subOrderList.push(obj)
      }
      this.axios.post('/neworder/orderLogisticsSplit/updateSplitOrder', params)
        .then(res => {
          console.log('单个修改订单生成电子面单的信息', res)
          if (res.code == 0) {
            // this.$message.success('拆单成功')
            // this.fetchData('init')
          }
        })
      // let timer = setTimeout(() => {

      // }, 500)

    },
    printT() {
      let ids = []
      ids.push(this.sId)
      let data1 = {
        orderLogisticsSplitIds: ids
      }
      this.axios.post('/neworder/order/logistics/changeDeBangLiver', data1)
        .then(res => {
          if (res.code == 0) {

          }
        })
      printTest(this.printData)
    },
    focusChangeCode(e, row) {
      // console.log('focusChangeCode===', index)
      let code = row.logisticsCompanyCode
      let timer = setTimeout(() => {
        this.getMonthCode(code)
      }, 500)
    },
    selectLD(code) {
      this.getMonthCode(code)
      this.getProductType(code)
      this.batchLogistics.logisticsCustomerCode = ''
      this.batchLogistics.logisticsProductType = ''
      this.$nextTick(() => {
        this.$refs['logisticsForm'].clearValidate()
      })
    },
    getMonthCode(code) {
      this.axios.get('/neworder/logisticsCompanyAccount/listByLogisticsCompany?companyCode=' + code)
        .then(res => {
          console.log('获取月码', res)
          if (res.code == 0) {
            let list = res.data.map(item => {
              return {
                value: item,
                label: item
              }
            })
            this.monthCodeList = list;
          }
        })
    },

    focusChange(e, row) {
      // console.log('visibleChange===', index)
      let code = row.logisticsCompanyCode
      let timer = setTimeout(() => {
        this.getProductType(code)
      }, 500)
      // this.getProductType(code)
    },
    getProductType(code) {
      this.axios.get('/neworder/logisticsCompany/getProductType?companyCode=' + code)
        .then(res => {
          console.log('寄件产品类型', res)
          if (res.code == 0) {
            this.productTypeList = res.data;
          }
        })
    },
    tableRowStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        console.log('columnIndex==', columnIndex)
        return 'padding: 0 !important'
      }
    },
    //撤销拆单
    qSplitOrder(row) {
      console.log(row)
      this.splitOrderId = row.orderId
      this.sType = row.splitType
      this.qSplitList = []
      this.isSOrder = true
      if (row.splitOrderList) {
        this.isNum = row.splitOrderList.length || 0
      }
      row.splitOrderList.forEach(item => {
        this.qSplitList.push(item.orderNo)
        if (item.splitOrderList) {
          item.splitOrderList.forEach(item1 => {
            this.qSplitList.push(item1.orderNo)
          })
        }
      })
    },
    //确认撤销拆单
    qSumitSplit() {
      this.axios.post('/neworder/order/split/cancelSplit', {
        orderId: this.splitOrderId,
        type: this.sType
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.isSOrder = false
            this.fetchData('search')
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.message)
          }
        })
    },
    changeSelect(row) {
      console.log(row.isSelected)
      let index = this.page.list.findIndex(e => { return e.id == row.id })
      console.log(index)
      if (row.isSelected == true) {
        this.page.list[index].isSelected = true
      } else {
        this.page.list[index].isSelected = false
      }

      this.$forceUpdate()
    },
    addCode(type, code, id, row) {
      this.optionCodeType = type
      if (type == 'add') {
        this.infoFormC.ebillCompanyCode = code
        this.infoFormC.id = null,
          this.infoFormC.companyName = ''
        this.infoFormC.code = ''
        this.infoFormC.collectionBank = ''
        this.infoFormC.collectionName = ''
        this.infoFormC.collectionAccount = ''
      } else {
        this.infoFormC.ebillCompanyCode = code
        this.infoFormC.id = row.id,
          this.infoFormC.companyName = row.companyName
        this.infoFormC.code = row.code
        this.infoFormC.collectionBank = row.collectionBank
        this.infoFormC.collectionName = row.collectionName
        this.infoFormC.collectionAccount = row.collectionAccount
      }
      this.infoFormC.ebillCompanyCode = code
      this.infoFormC.id = id
      this.showNewCodeDialog = true
    },
    deleteCode(code, id) {
      this.isDeleteCode = true
      this.dIds = []
      this.dIds.push(id)
    },
    submitDeleteCode() {
      this.axios.post('/neworder/order/logistics/deleteComAccount', {
        ids: this.dIds,
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.isDeleteCode = false
            this.getShowCodeData()
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.message)
          }
        })
    },
    submitCode() {
      this.axios.post('/neworder/order/logistics/saveComAccount', this.infoFormC)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.showNewCodeDialog = false;
            if (this.optionCodeType == 'add') {
              this.$message.success('添加成功')
            } else {
              this.$message.success('编辑成功')
            }
            this.getShowCodeData()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getShowCodeData() {
      this.codeList = []
      console.log(this.logisticsCompanyList)
      this.logisticsCompanyList.forEach(item => {
        let obj = {
          code: item.value,
          company: item.label,
          list: []
        }
        this.codeList.push(obj)
      })
      // this.codeList.forEach(itm => {
      //   itm.list = []
      // })
      this.axios.get('/neworder/order/logistics/getComAccountList?ebillCompanyCode=' + '')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            res.data.forEach(item => {
              this.codeList.forEach(itm => {
                if (item.logisticsCompanyCode == itm.code) {
                  itm.list.push(item)
                }
              })

            })
          } else {
            this.$message.error(res.message)
          }
        })
    },
    showSelectLogistics(type) {
      if (this.waitOrderList.length == 0) {
        this.$message.error('请选择订单')
        return
      }
      this.isBatch = type;
      this.isSelectLogistics = true
      this.batchLogistics.logisticsCompanyCode = null
      this.batchLogistics.logisticsCustomerCode = null
      this.batchLogistics.logisticsProductType = null
      this.batchLogistics.sendAddressId = null
      this.batchLogistics.logisticsPrintRemark = ''
      this.$nextTick(() => {
        this.$refs['logisticsForm'].clearValidate()
      })
      this.isF = false
    },
    openShowCode() {
      this.showCodeDialog = true
      this.getShowCodeData()
    },
    saveAddr() {
      if (this.addressList.length == 0) {
        this.$message.error('未填寄件信息')
        return
      }
      if (this.addressList.length != 0) {
        for (let i = 0; i < this.addressList.length; i++) {
          if (!this.addressList[i].name || !this.addressList[i].phone || !this.addressList[i].address) {
            this.$message.error('请填写完整寄件信息')
            return
          }
        }
      }
      this.axios.post('/neworder/order/logistics/saveSendAddress', this.addressList)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.showAddrDialog = false;
            this.$message.success('保存成功')
            this.showAddrDialogFn(3)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    addAddr() {
      this.addressList.push({
        name: '',
        phone: '',
        address: ''
      })
    },
    delAddr(index) {
      this.addressList.splice(index, 1)
    },
    showAddrDialogFn(type) {
      console.log(type)
      if (!type) {
        this.showAddrDialog = true
      }
      this.axios.post('/neworder/order/logistics/sendAddressList')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.addressList = res.data;
            this.tableAddressList = this.addressList.map(item => {
              return {
                value: item.id,
                label: item.name + ' ' + item.phone + ' ' + item.address
              }
            })
            console.log(this.tableAddressList)
          }
        })
    },
    splitOrder(row, index) {
      console.log(this.page.list, row)
      row.isShow = !row.isShow
      if (row.isShow == true) {
        this.$refs.tableData.toggleRowExpansion(row, true)
        this.expandRowKeys.push(String(row.id))
        if (row.splitOrderList) {
          row.splitOrderList.forEach((item1, index1) => {
            this.expandRowKeys.push(String(item1.id))
          })
        }
      } else {
        this.$refs.tableData.toggleRowExpansion(row, false)
        this.expandRowKeys = []
      }


      // this.expandRowKeys = []
      // this.expandRowKeys.push(row.id)
      // console.log(row)
      // if (row.splitOrderList) {
      //   for (let i = 0; i < row.splitOrderList.length; i++) {
      //     this.expandRowKeys.push(row.splitOrderList[i].id)
      //     row.splitOrderList[i].splitOrderList.forEach(item => {
      //       this.expandRowKeys.push(item.id)
      //     })
      //   }
      // }
      console.log(this.expandRowKeys)
      // this.page.list[index].isShow = !this.page.list[index].isShow
    },
    scrollToTop(e) {
      // console.log(e)
      let scrollTop = e.target.scrollTop;
      // console.log(scrollTop, "滚动距离");
      if (scrollTop >= 500) {
        this.$nextTick(() => {
          this.tableHeight = '800';
        })

      }
      if (scrollTop == 0) {
        this.tableHeight = ''
      }

      // 　  　var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 　　  console.log(scrollTop)
    },
    nowInDateBetwen(d1, d2, d3) {
      //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
      var dateBegin = new Date(d1.replace(/-/g, "/"));//将-转化为/，使用new Date
      var dateEnd = new Date(d2.replace(/-/g, "/"));//将-转化为/，使用new Date
      // var dateBegin = new Date(d1);//将-转化为/，使用new Date
      // var dateEnd = new Date(d2);//将-转化为/，使用new Date
      // console.log('dateNow==',d3)
      var dateNow = new Date(d3.replace(/-/g, "/"));//获取当前时间
      // console.log('dateBegin==',dateNow)
      var beginDiff = dateNow.getTime() - dateBegin.getTime();//时间差的毫秒数
      var beginDayDiff = Math.floor(beginDiff / (24 * 3600 * 1000));//计算出相差天数

      var endDiff = dateEnd.getTime() - dateNow.getTime();//时间差的毫秒数
      var endDayDiff = Math.floor(endDiff / (24 * 3600 * 1000));//计算出相差天数
      if (endDayDiff < 0) {//已过期
        return false
      }
      if (beginDayDiff < 0) {//没到开始时间
        return false;
      }
      return true;
    },
    handlerCascaderValueDan(val) {
      console.log(val)
    },
    //查询失败面单方法
    dialogClickFailDan(type) {

      let data = null
      if (type == 'reset') {
        this.$nextTick(() => {
          this.$refs['formAttrx'].resetFields()
        })
        data = {
          "batchNo": "",
          "orderNo": "",
          "postInfo": "",
          "createdTimeStart": "",
          "createdTimeEnd": "",
          "remark": "",
          "logisticsCompanyCode": "",
          "pageNo": 1,
          "pageSize": 10
        }
      } else {
        data = {
          "batchNo": this.searchFormConfig2.formData.batchNo,
          "orderNo": this.searchFormConfig2.formData.orderNo,
          "postInfo": this.searchFormConfig2.formData.postInfo,
          "createdTimeStart": this.searchFormConfig2.formData.createdTime && this.searchFormConfig2.formData.createdTime.length > 0 ? this.searchFormConfig2.formData.createdTime[0] : '',
          "createdTimeEnd": this.searchFormConfig2.formData.createdTime && this.searchFormConfig2.formData.createdTime.length > 0 ? this.searchFormConfig2.formData.createdTime[1] : '',
          "remark": this.searchFormConfig2.formData.remark,
          "logisticsCompanyCode": this.searchFormConfig2.formData.logisticsCompanyCode,
          "pageNo": this.currentPageFailDan,
          "pageSize": this.pageSizeFailDan
        }
      }
      this.getEbillErrorOrderList(data)
    },
    getEbillErrorOrderList(data) {
      this.axios.post('/neworder/orderLogisticsSplit/getEbillErrorOrderList', data)
        .then(res => {
          console.log('失败面单列表==', res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              item.sendAddressId = item.sendAddressId + ''
              item.productTypeList = []
              item.monthCodeList = []
              this.axios.get('/neworder/logisticsCompany/getProductType?companyCode=' + item.logisticsCompanyCode)
                .then(res1 => {
                  if (res1.code == 0) {
                    item.productTypeList = res1.data || []
                  }
                })
              this.axios.get('/neworder/logisticsCompanyAccount/listByLogisticsCompany?companyCode=' + item.logisticsCompanyCode)
                .then(res2 => {
                  if (res2.code == 0) {
                    let list = res2.data.map(itm => {
                      return {
                        value: itm,
                        label: itm
                      }
                    })
                    item.monthCodeList = list;
                  }
                })
            })
            this.ebillErrorOrderList = res.data.list
            this.totalNumFailDan = res.data.totalNum
            // this.failOrder = true;
          }

        })
    },
    handleSelectionChangeFailDan(val) {
      console.log(val)
      this.waitOrderList = val
    },
    handleCurrentChangeFailDan(val) {
      this.currentPageFailDan = val
      this.dialogClickFailDan('search')
    },
    handleSizeFailDanChange(val) {
      this.pageSizeFailDan = val
      this.dialogClickFailDan('search')
    },
    qProuductOrder() {
      this.isROrder = false
      if (this.isFailO == false) {
        this.dialogClickDan('search')
      } else {
        this.dialogClickFailDan('search')
      }

    },
    // qProuductOrder(){
    //   this.dialogClickDan('search')
    // },
    dialogClickDan(type) {
      this.isROrder = false
      let data = {}
      if (type == 'reset') {
        this.$refs['formAttrxsc'].resetFields()
      }
      Object.keys(this.searchFormConfig1.formData).forEach(e => {
        // 调用自己定义好的筛选方法

        if (type == 'search') {
          if (e !== 'createdTime') {
            data[e] = this.searchFormConfig1.formData[e]
          }
        } else {
          if (e !== 'createdTime') {
            data[e] = this.searchFormConfig1.formData[e]
          }
        }


      })

      if (this.searchFormConfig1.formData.createdTime && this.searchFormConfig1.formData.createdTime.length > 0 && this.searchFormConfig1.formData.createdTime[0]) {
        data.createdTimeEnd = this.searchFormConfig1.formData.createdTime[1]
        data.createdTimeStart = this.searchFormConfig1.formData.createdTime[0]
      } else {
        data.createdTimeEnd = null
        data.createdTimeStart = null
      }
      data.pageNo = 1;
      delete data.createdTime
      this.onProuductOrder(data)
      console.log(this.searchFormConfig1.formData, 'searchFormVal', data)
      return
      let arr = this.tableList
      if (val.createdTime && val.createdTime.length > 0) {
        let timeArr = val.createdTime;
        delete val.createdTime
        // console.log('timeArr==', timeArr)
        Object.keys(val).forEach(e => {
          // 调用自己定义好的筛选方法
          console.log(val[e])
          arr = this.filterFunc(val[e], e, arr, timeArr)
        })

      } else {

        // 通过遍历key值来循环处理
        Object.keys(val).forEach(e => {
          // 调用自己定义好的筛选方法
          console.log(val[e])
          arr = this.filterFunc(val[e], e, arr)
        })
        // 为表格赋值
        // this.tableListx = arr
        console.log(arr)
      }
      // this.totalNumDan = arr.length;
      this.currentPageDan = 1;
      this.tableListx = arr.length > 0 ? this.getNeedArr(arr, this.pageSizeDan)[this.currentPageDan - 1] : []
    },
    filterFunc(val, target, filterArr, timeArr) {

      // 参数不存在或为空时，就相当于查询全部
      return filterArr.filter(p => {
        let flag = false;
        let flag2 = false;
        let flag3 = false;
        let flag4 = false;
        if (target == 'postUserInfo') {
          flag3 = true
          if (p['postContact'].indexOf(val) > -1 || p['postName'].indexOf(val) > -1) {
            flag2 = true;
          } else {
            flag2 = false;
          }
          console.log(flag2)
        } else {
          flag2 = true;
          console.log(p[target].indexOf(val) > -1)
          if (p[target].indexOf(val) > -1) {
            flag3 = true
          } else {
            flag3 = false
          }
        }
        if (timeArr) {
          if (this.nowInDateBetwen(timeArr[0], timeArr[1], p.orderTime)) {
            flag4 = true
          } else {
            flag4 = false
          }

        } else {
          flag4 = true
        }
        console.log(flag2, flag3, flag4)
        if (flag2 && flag3 && flag4) {
          flag = true
        } else {
          flag = false
        }
        console.log(flag)
        return flag
      }) // 可以自己加一个.toLowerCase()来兼容一下大小
    },
    //切换每页条数容量
    handleSizeChangeDan(val) {
      this.currentPageDan = 1;
      this.pageSizeDan = val;
      this.onProuductOrder()
      // this.getList();
    },
    //切换当前页
    handleCurrentChangeDan(val) {
      this.currentPageDan = val;
      this.onProuductOrder()
      // this.getList();
    },
    getList() {
      // this.totalNumDan = this.tableList.length;
      // this.tableListx = this.getNeedArr(this.tableList, this.pageSizeDan)[this.currentPageDan - 1]
      // console.log('前端分页', this.tableListx)
    },
    // 前端处理分页
    getNeedArr(array, size) {       //获取所需指定长度分割的数组;参数1为用于分割的总数组,参数2为分割数组后每个小数组的长度
      const length = array.length;
      //判断不是数组，或者size没有设置，size小于1，就返回空数组
      if (!length || !size || size < 1) {
        return [];
      }

      let index = 0; //用来表示切割元素的范围start
      let resIndex = 0; //用来递增表示输出数组的下标

      //根据length和size算出输出数组的长度，并且创建它。
      let result = new Array(Math.ceil(length / size));
      //进行循环
      while (index < length) {
        //循环过程中设置result[0]和result[1]的值。该值根据array.slice切割得到。
        result[resIndex++] = array.slice(index, (index += size));
      }
      //输出到新数组
      return result;
    },
    againPrint() {
      this.isAgainPrint = true
    },
    getLogisticsCompany() {
      let params = {

      }
      this.axios.get('/neworder/order/logistics/expressCompanyList', params).then((res) => {
        console.log(res)
        if (res.code == 0) {

        } else {
          this.$message.error(res.message)
        }
      })
    },
    iSCD() {
      this.isSOrder = true
    },
    cOrder(row) {
      this.isCOrder = true
      this.cOrderId1 = row.splitOrderId
    },
    submitCmorder() {
      this.axios.post('/neworder/orderLogisticsSplit/cancelPrint', {
        orderId: this.cOrderId1
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('撤销成功')
          this.isCOrder = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onPrintOrder() {
      this.currentStatus1 = ''
      this.isPrintOrder = true
      let arr = this.itemListAll1
      this.searchFormConfig3.formconfig.itemList = JSON.parse(JSON.stringify(arr))
      this.searchFormConfig3.formconfig.itemList.splice(8, 1)
      this.searchFormConfig3.formconfig.itemList.forEach((item, index) => {
        if (item.prop == 'logisticsCompanyCode') {
          this.searchFormConfig3.formconfig.itemList[index].option = this.logisticsCompanyList
        }

        if (item.prop == 'multipleBagFlag') {
          let list = [{ label: '是', value: true }, { label: '否', value: false }]
          this.searchFormConfig3.formconfig.itemList[index].option = list
        }
      })
      this.fetchData3()
    },
    fetchData3(type) {
      if (type == 'reset') {
        this.$nextTick(() => {
          this.$refs['searchForm1'].resetFields()
        })

        this.pageNo3 = 1
        this.searchFormConfig3.formData = {
          "batchNo": "",
          "orderNo": "",
          "logisticsNo": "",
          "logisticsCompanyCode": "",
          "multipleBagFlag": "",
          "printTime": null,
          "createdTime": null,
          "orderTime": null,
          "cancelTime": null,
        }
      }
      let params = {
        pageNo: this.pageNo3,
        pageSize: this.pageSize3
      }
      console.log(this.searchFormConfig3.formData)
      params = Object.assign(params, this.searchFormConfig3.formData)
      if (params.orderTime) {
        params.orderTimeStart = params.orderTime[0]
        params.orderTimeEnd = params.orderTime[1]
      }
      if (params.createdTime) {
        params.createdTimeStart = params.createdTime[0]
        params.createdTimeEnd = params.createdTime[1]
      }
      if (params.printTime) {
        params.printTimeStart = params.printTime[0]
        params.printTimeEnd = params.printTime[1]
      }
      if (params.cancelTime) {
        params.cancelTimeEnd = params.cancelTime[0]
        params.cancelTimeEnd = params.cancelTime[1]
      }
      this.axios.post('/neworder/orderLogisticsSplit/splitPrintOrderList', params).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.printOrderList = res.data.list
          this.totalNum3 = res.data.totalNum
          this.getStatusCount1(params)
        }
      })
    },
    // 打印订单分页数量统计查询接口
    getStatusCount1(params) {
      params.status = ''
      this.axios.post('/neworder/orderLogisticsSplit/splitPrintOrderCount', params).then((res) => {
        if (res.code == 0) {
          this.logisticsStatus1.all.total = res.data.total // 全部
          this.logisticsStatus1.waitPrintCount.total = res.data.waitPrintCount // 待打印
          this.logisticsStatus1.waitPickCount.total = res.data.waitPickCount // 待揽收
          this.logisticsStatus1.pickedCount.total = res.data.pickedCount // 已揽收
          this.logisticsStatus1.cancelCount.total = res.data.cancelCount // 撤销面单
        } else {
          this.$message.error(res.message)
        }

      }).catch((err) => {
        console.log(err)
      })
    },
    changeL(index, e) {
      console.log(index, e)
      console.log(this.page.list)
      this.$nextTick(() => {
        this.page.list[index].companyL = e

        this.$forceUpdate()
      })

    },
    getLogisticsCompanyList() {
      this.axios.get('/neworder/logisticsCompany/list')
        .then(res => {
          console.log('物流公司', res)
          if (res.code == 0) {
            //   searchFormConfig1: {
            // formconfig: {
            //   labeWidth: 82, // 表单宽度
            //   itemList
            let list = res.data.map(item => {
              return {
                label: item.name,
                value: item.code
              }
            })
            console.log(list)
            this.logisticsCompanyList = list;
            this.searchFormConfig1.formconfig.itemList.forEach((item, index) => {
              if (item.prop = 'logisticsCompanyCode') {
                this.searchFormConfig1.formconfig.itemList[index].option = list
              }
            })
          }
          console.log('物流公司列表', res)
        })
    },

    getEbillErrorCount() {
      this.axios.get('/neworder/orderLogisticsSplit/getEbillErrorCount')
        .then(res => {
          console.log('失败面单数量==', res)
          if (res.code == 0) {
            this.ebillErrorCount = res.data
          }
        })
    },
    regenerateFn(idx) {
      this.waitOrderList = []
      this.waitOrderList.push(this.ebillErrorOrderList[idx])
      console.log(this.waitOrderList, this.ebillErrorOrderList[idx])
      this.createEbillBatch()
      this.isFailO = true
    },
    createEbillBatch() {
      if (this.waitOrderList.length == 0) {
        this.$message.warning('请选择订单')
        return
      }
      let some = this.waitOrderList.some(item => {
        return !item.logisticsCompanyCode || !item.logisticsProductType || !item.sendAddressId
      })
      if (some) {
        this.$message.warning('请确认所选订单信息填写完毕！')
        return
      }
      let orderNoList = this.waitOrderList.map(item => {
        return item.orderNo
      })
      this.axios.post('/neworder/orderLogisticsSplit/createEbillBatch', { orderNoList: orderNoList })
        .then(res => {
          if (res.code == 0) {
            // this.$message.success('生成成功')
            this.isROrder = true
            this.successNum = res.data.successNum
            this.failNum = res.data.failNum
            this.waitOrderList = []
            this.getEbillErrorCount()
            if (this.isBatch == 2) {
              this.dialogClickFailDan()
            }
          } else {
            this.$message.error(res.message)
          }

        })
    },
    openProuductOrder() {
      this.$nextTick(() => {
        this.$refs['formAttrxsc'].resetFields()
      })
      this.searchFormConfig1.formData = {
        // orderIdList: [],
        orderNo: '',
        postInfo: '',
        createdTimeStart: '',
        createdTimeEnd: '',
        remark: '',
        logisticsCompanyCode: '',
        pageNo: 1,
        pageSize: 10,
        createdTime: null
      }
      this.onProuductOrder()
    },
    openFailOrder() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs['formAttrx'].resetFields()
        })
      }, 100)
      this.failOrder = true;
      this.dialogClickFailDan('reset')
    },
    onProuductOrder(val) {
      this.isProductOrder = true
      let data = val ? val : this.searchFormConfig1.formData;
      console.log(this.page.list)
      let isSelected = this.page.list.some(item => {
        return item.isSelected
      })
      let orderIdList = []
      if (!isSelected) {
        orderIdList = this.page.list.map(item => {
          return item.orderId
        })
      } else {
        this.page.list.forEach(item => {
          if (item.isSelected) {
            orderIdList.push(item.orderId)
          }
        })
      }
      console.log(orderIdList)
      // return
      data.pageNo = this.currentPageDan;
      data.pageSize = this.pageSizeDan;
      data.orderIdList = orderIdList
      delete data.createdTime
      console.log('生成电子面单参数', data)
      this.axios.post('/neworder/orderLogisticsSplit/pageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              item.sendAddressId = item.sendAddressId ? item.sendAddressId + '' : null
              item.productTypeList = []
              item.monthCodeList = []
              this.axios.get('/neworder/logisticsCompany/getProductType?companyCode=' + item.logisticsCompanyCode)
                .then(res1 => {
                  if (res1.code == 0) {
                    item.productTypeList = res1.data || []
                  }
                })
              this.axios.get('/neworder/logisticsCompanyAccount/listByLogisticsCompany?companyCode=' + item.logisticsCompanyCode)
                .then(res2 => {
                  if (res2.code == 0) {
                    let list = res2.data.map(itm => {
                      return {
                        value: itm,
                        label: itm
                      }
                    })
                    item.monthCodeList = list;
                  }
                })
            })
            this.tableListx = res.data.list
            this.totalNumDan = res.data.totalNum
            this.showAddrDialogFn(3)
          }
        })
    },
    //获取物流公司
    handlerCascaderValue(value) {
      console.log(value, 'value')
      this.orgCodevalue = value
    },
    //导出全部订单
    totalExport(type) {
      console.log(this.searchFormVal)
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        beginTime: '',
        endTime: '',
        status: ''
      }
      if (this.searchFormVal.createdTime) {
        data.createdTimeStart = this.searchFormVal.createdTime[0]
        data.createdTimeEnd = this.searchFormVal.createdTime[1]
      }
      data = Object.assign(data, this.searchFormVal)
      if (data.createdTime) {
        delete data.createdTime
      }
      if (data.postTime) {
        delete data.postTime
      }
      if (data.orgCode) {
        data.orgCode = this.parseOrgCodeMutil(data.orgCode)
      }
      if (type == 'selfPickupIn') {
        data.selfPickupInStatus = 1
      }
      delete data.checkbox
      console.log(data)
      this.$api.totalExport(data).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.downloadlink(res.data)
        }
      })
    },
    //导出售后件
    afterExport() {
      console.log(this.searchFormVal)
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        beginTime: '',
        endTime: ''
      }
      if (this.searchFormVal.createdTime) {
        data.createdTimeStart = this.searchFormVal.createdTime[0]
        data.createdTimeEnd = this.searchFormVal.createdTime[1]
      }
      data = Object.assign(data, this.searchFormVal)
      if (data.createdTime) {
        delete data.createdTime
      }
      if (data.postTime) {
        delete data.postTime
      }
      if (data.orgCode) {
        data.orgCode = this.parseOrgCodeMutil(data.orgCode)
      }
      delete data.checkbox
      console.log(data)
      this.$api.afterExport(data).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.downloadlink(res.data)
        }
      })
    },
    // 导出物流数据
    importLogisticsData(typeStatus) {
      if (!this.searchFormConfig.formData.orgCode || this.searchFormConfig.formData.orgCode.length === 0) {
        return this.$message.warning('请选择部门！')
      }
      this.btnLoading = true
      // this.dialogClick()
      // console.log(this.$refs.formAttr.submitForm)
      this.$refs.formAttr.submitForm('ruleForm')
      console.log(this.searchFormVal)
      const ids = []
      // if (this.multipleSelection.length != 0) {
      //   this.multipleSelection.forEach((item) => {
      //     ids.push(item.orderId)
      //   })
      // }
      this.page.list.forEach((item) => {
        if (item.isSelected == true) {
          ids.push(item.orderId)
        }

      })
      let data = {
        orderIdList: ids,
        status: typeStatus,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      const searchForm = this.searchFormVal
      data = Object.assign(data, searchForm)
      if (data.orgCode) {
        data.orgCode = this.parseOrgCodeMutil(searchForm.orgCode)
      }
      if (data.postTime) {
        data.postTimeStart = data.postTime[0]
        data.postTimeEnd = data.postTime[1]
      }
      if (data.createdTime) {
        data.createdTimeStart = data.createdTime[0]
        data.createdTimeEnd = data.createdTime[1]
      }

      console.log(searchForm)
      if (!data.postTimeEnd || !data.postTimeStart) {
        if (typeStatus !== 3) {
          this.btnLoading = false
          return this.$message.warning('请选择时间！')
        }
      }
      // if (!data.orgCode) {
      //   return this.$message.warning('请选择公司部门！')
      // }
      if (this.searchFormVal.purchaseFlag) {
        data.purchaseFlag = this.searchFormVal.purchaseFlag;
      }
      this.$api.logisticsExport(data).then((res) => {
        if (res.code == 0) {
          res.data.forEach(item => {
            this.downloadlink(item)
          })
          this.btnLoading = false
          // this.downloadlink(res.data)
          this.$message.success('操作成功！')
          this.dialog.visible = false
          this.fetchData('search')
        } else {
          this.btnLoading = false
        }
      }).catch((err) => {
        console.log(err)
        this.btnLoading = false
      })
    },
    // 复制
    copyInfo(row) {
      console.log(row, 'row')
      const that = this
      // let inline = this.line.find((res) => res.id == row.userDitch);
      const info =
        (row.orderNo == null ? '无' : row.orderNo)
      that.$copyText(info).then(
        function (e) {
          that.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          that.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    // 复制
    copyInfo3(row) {
      console.log(row, 'row')
      const that = this
      // let inline = this.line.find((res) => res.id == row.userDitch);
      const info =
        (row == null ? '无' : row)
      that.$copyText(info).then(
        function (e) {
          that.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          that.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    // 物流异常弹框
    wuliuAbnormal(row) {
      // console.log(row, 'row')
      this.wuliuStatus.resource = ''
      this.wuliuStatus.remark = ''
      this.dialog.visible = true
      this.dialog.title = '物流异常'
      this.dialog.width = '640px'
      this.dialog.type = 'wuliuAbnormal'
      this.wuliuAbnormalId = row.orderNo
    },
    // 物流异常弹框确定提交
    handlerAuditsubmit() {
      if (this.wuliuStatus.resource == '') {
        this.$message.warning('请选择异常原因！')
        return
      }
      const data = {
        orderNo: this.wuliuAbnormalId,
        logsticsExceptionReson: this.wuliuStatus.resource,
        exceptinRemeark: this.wuliuStatus.remark
      }
      this.$api.updateOrderMainLogisticsException(data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.dialog.visible = false
          this.fetchData('search')
        }
      })
    },

    // 下载到本地
    downloadThisLocality() {
      this.$api.afterDownloadExportError(this.importLogisticsList.list).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.fetchData()
        }
      })
    },
    // 重新提交
    resubmit() {
      // console.log(this.dialoglogistics.type)
      let required
      if (this.dialoglogistics.type == 'afterSaleLeadingInlast') {
        required = this.$api.afterReImportLogistics
      } else {
        required = this.$api.reImportLogistics
      }
      // console.log(this.importLogisticsList)
      required(this.importLogisticsList.list).then(res => {
        if (res.code === 0) {
          this.dialoglogistics.visible = false // 关闭弹窗
          // this.importLogisticsList = res.data
          this.$message.success('操作成功')
          this.fetchData('search')
        } else if (res.code === 104) {
          // console.log(res)
          this.importLogisticsList = res.data
          // this.$message.warning('提交失败！')
          this.fetchData()
        } else {
          console.log(this.importLogisticsList, 'this.importLogisticsList')
        }
      }).catch((err) => {
        console.log(err)
        // this.loading = false
      })
    },
    // 修改售后物流单号，提交状态
    modifyState(state) {
      // console.log('修改售后物流单号，提交状态', state)
      this.fetchData('search')
      // 提交后，关闭并还原值
      this.closeDialog()
    },
    // 关闭订单确定
    handlerCloseOrderSubmit() {
      if (this.setCloseOrder) {
        const data = {
          id: this.dialog.row.orderId,
          closeReason: this.setCloseOrder
        }
        this.$api.wuliuCloseOrder(data).then(res => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.dialog.visible = false
            this.fetchData('search')
          }
        })
      } else {
        this.$message.warning('请选择关闭订单原因！')
      }
    },

    // 导入物流单号模板下载
    downloadTemplate() {
      const exportModelUrl = this.sessionDictionaries.export_model_url
      let modelIndex
      // console.log(this.currentStatus, this.logisticsStatus.stayDeliverGoods.values)
      if (this.currentStatus === this.logisticsStatus.deliverGoods.values || this.currentStatus === this.logisticsStatus.stayDeliverGoods.values) {
        modelIndex = exportModelUrl.findIndex(item => { return item.dictId === 'logistics_number_import_success' }) // 待发货
      } else {
        modelIndex = exportModelUrl.findIndex(item => { return item.dictId === 'after_number_import_success' }) // 售后件
      }
      // this.downloadlink('https://5eck-down.oss-cn-shenzhen.aliyuncs.com/model/五域v1.2.2导入导出文件模板/%E5%AF%BC%E5%85%A5%E7%89%A9%E6%B5%81%E5%8D%95%20-%20%E6%88%90%E5%8A%9F.xls?versionId=CAEQJxiBgMDOsa_kgxgiIDEwNTJhMTVmZTgyYTQ1MzE4NmRjYmQ0ZjFjZTk4MDg2')
      this.downloadlink(exportModelUrl[modelIndex].dictName)
    },
    // 导入物流单
    orderImport(fileObj) {
      this.file = fileObj.file
    },
    // 导入数据请求
    // 一键导入
    templateMode() {
      this.$refs.tops.clearFiles()
      const formData = new FormData()
      formData.append('file', this.file)
      // console.log(this.file, 'this.file')
      if (this.file == '') {
        return this.$message.warning('请上传文件！')
      }
      let required
      if (this.dialoglogistics.type == 'afterSaleLeadingIn') { // 售后件
        required = this.$api.afterImportLogistics
      } else {
        required = this.$api.importLogistics
      }
      required(formData).then(res => {
        // console.log(res)
        if (res.code == 0) {
          this.$message.success('导入成功！')
          this.dialoglogistics.visible = false
          this.downloadlink(res.data)
          this.fetchData('search')
        } else if (res.code == 104) {
          // this.$message.warning('导入失败！')
          this.importLogisticsList = res.data
          // this.dialoglogistics.visible = false
          if (this.dialoglogistics.type == 'afterSaleLeadingIn') {
            this.dialoglogistics.type = 'afterSaleLeadingInlast'
          }
          if (this.dialoglogistics.type == 'batchAmend') {
            this.dialoglogistics.type = 'batchAmendlast'
          }
          if (this.dialoglogistics.type == 'importlogistics') {
            this.dialoglogistics.type = 'importlogisticslast'
          }
          this.dialoglogistics.title = '导入物流单号失败'
          this.dialoglogistics.width = '1062px'
          this.dialoglogistics.visible = true
        } else {
          console.log('err')
        }
        this.getCommWarehouse()
      }).catch(err => {
        console.log(err)
      })
    },
    // 仓库列表
    getCommWarehouse() {
      const params = { pageNo: 1, pageSize: 10000 }
      this.$api.commWarehouse(params).then((res) => {
        this.commWarehouseList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    // 批量修改物流单号
    batchAmend() {
      this.dialoglogistics.visible = true
      this.dialoglogistics.title = '批量修改物流单号'
      this.dialoglogistics.width = '640px'
      this.dialoglogistics.type = 'batchAmend'
    },
    // 导入物流单号
    leadingIn() {
      this.dialoglogistics.visible = true
      this.dialoglogistics.title = '导入物流单号'
      this.dialoglogistics.width = '640px'
      this.dialoglogistics.type = 'importlogistics'
    },
    // 售后件导入物流单
    afterSaleLeadingIn() {
      this.dialoglogistics.visible = true
      this.dialoglogistics.title = '导入物流单号'
      this.dialoglogistics.width = '640px'
      this.dialoglogistics.type = 'afterSaleLeadingIn'
    },
    // 导出发货确定按钮
    deriveDownload() {
      this.btnLoading = true;
      this.dialog.visible = false
      const ids = []
      // if (this.multipleSelection.length != 0) {
      //   this.multipleSelection.forEach((item) => {
      //     ids.push(item.orderId)
      //   })
      // }
      this.page.list.forEach((item) => {
        if (item.isSelected == true) {
          ids.push(item.orderId)
        }

      })
      // console.log(this.multipleSelection,ids)
      // return
      if (this.orgCodevalue) {
        this.orgCodevalue = this.parseOrgCodeMutil(this.orgCodevalue)
      }
      const data = {
        orderIdList: ids,
        status: 2,
        orgCode: this.orgCodevalue
      }
      if (this.searchFormVal.orderGenerateType) {
        data.orderGenerateType = this.searchFormVal.orderGenerateType;
      }
      if (this.searchFormVal.purchaseFlag) {
        data.purchaseFlag = this.searchFormVal.purchaseFlag;
      }
      //return console.log(data,this.searchFormVal)
      this.$api.logisticsExport(data).then((res) => {
        if (res.code == 0) {
          res.data.forEach(item => {
            this.downloadlink(item)
          })
          // this.downloadlink(res.data)
          this.$message.success('操作成功！')

          this.btnLoading = false
          this.fetchData('search')
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 导出拣货确定按钮
    deriveDownload2() {
      this.btnLoading = true;
      this.dialog.visible = false
      const ids = []
      // if (this.multipleSelection.length != 0) {
      //   this.multipleSelection.forEach((item) => {
      //     ids.push(item.orderId)
      //   })
      // }
      this.page.list.forEach((item) => {
        if (item.isSelected == true) {
          ids.push(item.orderId)
        }

      })
      // console.log(this.multipleSelection,ids)
      // return
      if (this.orgCodevalue) {
        this.orgCodevalue = this.parseOrgCodeMutil(this.orgCodevalue)
      }
      const data = {
        orderIdList: ids,
        status: 2,
        orgCode: this.orgCodevalue,
        updateStatusFlag: 0
      }
      if (this.searchFormVal.orderGenerateType) {
        data.orderGenerateType = this.searchFormVal.orderGenerateType;
      }
      if (this.searchFormVal.purchaseFlag) {
        data.purchaseFlag = this.searchFormVal.purchaseFlag;
      }
      // console.log('>>>>', data, this.searchFormVal)
      this.$api.logisticsExport(data).then((res) => {
        if (res.code == 0) {
          res.data.forEach(item => {
            this.downloadlink(item)
          })
          // this.downloadlink(res.data)
          this.$message.success('操作成功！')

          this.btnLoading = false
          this.fetchData('search')
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 导出发货确定按钮
    deriveDownload1() {
      // this.btnLoading = true;
      this.dialog.visible = false
      const ids = []
      if (this.waitOrderList.length != 0) {
        this.waitOrderList.forEach((item) => {
          ids.push(item.id)
        })
      }
      var params = {
        orderIdList: ids,
        pageNo: this.currentPageFailDan,
        pageSize: this.pageSizeFailDan
      }
      params = Object.assign(params, this.searchFormConfig2.formData)
      if (this.searchFormConfig2.formData.createdTime) {
        params.createdTimeStart = this.searchFormConfig2.formData.createdTime[0]
        params.createdTimeEnd = this.searchFormConfig2.formData.createdTime[1]
      } else {
        params.createdTimeStart = ''
        params.createdTimeEnd = ''
      }
      this.axios.post('/neworder/order/logistics/logisticsFailedExport', params).then((res) => {
        if (res.code == 0) {
          res.data.forEach(item => {
            this.downloadlink(item)
          })
          // this.downloadlink(res.data)
          this.$message.success('操作成功！')

          // this.btnLoading = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 导出发货
    deriveDeliverGoods() {
      if (!this.searchFormConfig.formData.orgCode || this.searchFormConfig.formData.orgCode.length === 0) {
        return this.$message.warning('请选择部门！')
      }
      if (this.multipleSelection.length != 0) {
        this.pageTotalNum = this.multipleSelection.length
      } else {
        this.pageTotalNum = this.page.totalNum
      }
      this.dialog.visible = true
      this.dialog.title = '导出发货'
      this.dialog.width = '540px'
      this.dialog.type = 'deriveDeliverGoods'
      this.titleName = '已备货'
    },
    // 导出拣货单
    deriveDeliverGoods1() {
      if (!this.searchFormConfig.formData.orgCode || this.searchFormConfig.formData.orgCode.length === 0) {
        return this.$message.warning('请选择部门！')
      }
      if (this.multipleSelection.length != 0) {
        this.pageTotalNum = this.multipleSelection.length
      } else {
        this.pageTotalNum = this.page.totalNum
      }
      this.dialog.visible = true
      this.dialog.title = '导出拣货单'
      this.dialog.width = '540px'
      this.dialog.type = 'deriveDeliverGoods1'
      this.titleName = '已备货'
    },
    exportFailOrder() {
      this.dialog.visible = true
      this.dialog.title = '导出发货'
      this.dialog.width = '540px'
      this.dialog.type = 'deriveFailOrder'
      if (this.waitOrderList.length != 0) {
        this.pageTotalNum = this.waitOrderList.length
      } else {
        this.pageTotalNum = this.totalNumFailDan

      }

    },
    // 操作 - 关闭订单后
    closeOrderData(state) {
      // 提交后，关闭并还原值
      this.closeDialog()
    },
    // 初始化，搜索需要的列表数据
    initSearchList() {
      const params = { pageNo: 1, pageSize: 1001 }
      this.getSalesAuthority(params) // 跟进客服
      this.getPlatformDataList(params) // 平台
      this.getShopDataList(params) // 店铺
      this.getOrgTreeList() // 公司部门
    },
    // 接受表单组件的数据
    dialogClick(val, state) {
      this.searchFormVal = val
      console.log(this.searchFormVal, 'searchFormVal')
      this.fetchData('search')
      // this.formFiledData = Object.assign(this.formFiledData, val)
      // console.log(this.formFiledData,'接受表单组件的数据');
    },
    // 接受表单组件的数据
    dialogClick1(val, state) {
      this.searchFormVal = val
      console.log(this.searchFormVal, 'searchFormVal')
      // this.fetchData('search')
      // this.formFiledData = Object.assign(this.formFiledData, val)
      // console.log(this.formFiledData,'接受表单组件的数据');
    },
    // 接受表单组件的数据
    dialogClick3(val, state) {
      this.searchFormVal3 = val
      this.fetchData3('search')
    },
    // 接受表单组件的数据
    dialogClick4(val, state) {
      this.searchFormVal3 = val
      if (this.searchFormVal3.logisticsCompanyCode) {
        this.fetchData3('search')
      }
    },
    // 公司部门
    getOrgTreeList(params) {
      // orgProcessOrgList
      const paramsVersion = { 'request': { 'orgName': '', 'orgType': '' }, 'version': '' }
      this.$api.orgTreeList(paramsVersion).then((res) => {
        this.orgCodeList = res.data

        // id 为 1 的超级管理员不做默认
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        if (userInfo && userInfo.id !== 1) {
          if (res.data[0].children) {
            // const orgCode = JSON.parse(sessionStorage.getItem('orgCode'))
            if (this.searchForm && this.searchForm.orgCode) {
              this.searchForm.orgCode = [...userInfo.orgCodes]
            }
          } else {
            this.searchForm.orgCode.push(userInfo.orgCode)
          }
          if (this.isFirst > 2) {
            this.fetchData('search')
          }
        }
        this.isFirst++
      }).catch((err) => {
        console.log(err)
      })
    },
    fetchData(type) {
      this.loadinglist = true
      if (type === 'reset') {
        this.$refs['searchForm'].resetFields()
        this.page.pageNo = 1
        this.page.pageSize = 10
        this.page.currentPage = 1
      }
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
      }
      // 自提中筛选
      if(this.page.status == 9){
          params.status = ' '
          params.selfPickupInStatus = 1
      }else{
        params.status = this.page.status
      }
      if (type === 'init') {
        let userInfo = sessionStorage.getItem('userInfo')
        if (userInfo) {
          userInfo = JSON.parse(userInfo)
        }
        if (userInfo.orgCode === 'DT574796048' || userInfo.orgCode === 'DT574801057' || userInfo.orgCode === 'DT575225021') {
          const orderGenerateType = '1'
          this.searchFormConfig.formData.orderGenerateType = orderGenerateType
          params['orderGenerateType'] = orderGenerateType
        }
      }
      if (type === 'status') {
        params['orderGenerateType'] = this.searchFormConfig.formData.orderGenerateType
      }
      if (params.orgCode) {
        params.orgCode = searchForm.orgCode[searchForm.orgCode.length - 1]
      }

      if (type === 'search' || type === 'changePage') {
        this.formType = 'search'
        if (type === 'search') {
          this.page.currentPage = 1
          this.page.pageNo = 1
          params.pageNo = 1
        }
        const searchForm = this.searchFormVal
        params.pageNo = this.page.pageNo
        params = Object.assign(params, searchForm)
        if (params.postTime) {
          params.postTimeStart = params.postTime[0]
          params.postTimeEnd = params.postTime[1]
        }
        if (params.createdTime) {
          params.createdTimeStart = params.createdTime[0]
          params.createdTimeEnd = params.createdTime[1]
        }

        if (params.orgCode) {
          params.orgCode = this.parseOrgCodeMutil(params.orgCode)
        }
        let arr = []
        if (this.searchFormVal.statusL) {
          arr.push(this.searchFormVal.statusL)
          params.statusList = arr
        } else {
          params.statusList = []
        }


        // params.categoryId = searchForm.categoryId[searchForm.categoryId.length - 1]
        // 去除字符串 前后 空格
        for (const item in params) {
          if (typeof params[item] === 'string') {
            params[item] = params[item].trim()
          }
        }
      }
      if (params.status == 1 || params.status == 3) {
        params.splitFlag = ''
      }
      let pageListFun
      if (params.status === 5) {
        pageListFun = this.$api.afterPageList
      } else {
        pageListFun = this.$api.logisticsPageList
      }
      if (this.extraStatus != '') {
        params.extraStatus = this.extraStatus
      }
      pageListFun(params).then((res) => {
        if (res.code === 0) {
          res.data.list.forEach((item, index) => {
            item.isShow = false
            item.isSelected = false
            // this.expandRowKeys.push(String(item.id))
            // if (item.splitOrderList) {
            //   item.splitOrderList.forEach((item1, index1) => {
            //     this.expandRowKeys.push(String(item1.id))
            //   })
            // }
          })
          console.log(res.data.list)
          res.data.list.forEach((item, index) => {
            console.log('id==', item.id)
            if (item.splitOrderList && item.splitOrderList.length > 0) {
              item.splitOrderList.forEach((item1, index1) => {
                console.log('splitId===', item1.id)
              })
            }

          })
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.tableList = this.page.list;
          this.showTable = false;
          this.$nextTick(() => {
            this.showTable = true;
          })
          this.getList()

        } else {
          console.log('goodsPageList - 失败', type)
        }
        this.loadinglist = false
        this.getStatusCount(params)// 物流订单分页数量统计查询接口
      }).catch((err) => {
        console.log(err)
        this.loadinglist = false
      })
    },
    // 物流订单分页数量统计查询接口
    getStatusCount(params) {
      // const params = {}
      params = {}
      this.$api.logisticsGetStatusCount(params).then((res) => {
        this.statusCount = res.data
        this.logisticsStatus.all.total = res.data.total // 全部
        this.logisticsStatus.stayStockUp.total = res.data.preArrangeCount // 已备货
        this.logisticsStatus.stockUp.total = res.data.arrangedCount // 已备货
        this.logisticsStatus.stayDeliverGoods.total = res.data.prePostCount // 待发货
        this.logisticsStatus.deliverGoods.total = res.data.postedCount // 已发货
        this.logisticsStatus.afterSale.total = res.data.afterSaleCount // 售后件
        this.logisticsStatus.selfPickup.total = res.data.selfPickupCount // 自提中
      }).catch((err) => {
        console.log(err)
      })
    },
    handleCurrentChange(currentChange) {
      this.page.pageNo = currentChange
      this.fetchData('changePage')
      console.log(currentChange)
    },
    handleSizeChange(sizeChange) {
      this.page.currentPage = 1
      this.page.pageSize = sizeChange
      this.fetchData('search')
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
      if (val.length != 0) {
        this.page.list.forEach(item => {
          item.isSelected = true
        })
      } else {
        this.page.list.forEach(item => {
          item.isSelected = false
        })
      }

    },
    handleCurrentChange3(currentChange) {
      this.pageNo3 = currentChange
      this.fetchData3('search')
    },
    handleSizeChange3(sizeChange) {
      this.pageNo3 = 1
      this.pageSize3 = sizeChange
      this.fetchData3('search')
    },
    handleSelectionChange3(val) {
      console.log(val)
      this.multipleSelection3 = val
    },
    handleSelectionChangeDan(val) {
      console.log('待生成电子面单==', val)
      this.waitOrderList = val;
    },
    // 每页条数
    handleSizeChangeDeriveRecord(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.onApplierExport()
    },
    // 当前页
    handleCurrentChangeDeriveRecord(val) {
      this.page.pageNo = val
      this.onApplierExport()
    },
    // 每页条数
    handleSizeLogisticsTable() {

    },
    // 当前页
    handleCurrentLogisticsTable() {

    },
    // 备货
    onStockUp(batch, obj) {
      // true 批量
      const params = { ids: [] }
      if (batch) {
        // const multipleSelection = this.multipleSelection
        // if (multipleSelection.length === 0) {
        //   return this.$message.warning('请选择数据！')
        // } else {
        //   multipleSelection.forEach(item => {
        //     params.ids.push(item.orderNo)
        //   })
        // }
        let ids = []
        this.page.list.forEach(item => {
          if (item.isSelected) {
            ids.push(item.orderNo)
          }
        })
        if (ids.length === 0) {
          return this.$message.warning('请选择数据！')
        } else {
          params.ids = ids
        }

      } else {
        params.ids.push(obj.orderNo)
      }
      this.$confirm('是否备货已选中的订单?', '备货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.logisticsDoArrange(params).then((res) => {
          if (res.code === 0) {
            this.fetchData('search')
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            console.log('失败')
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 取消发货
    onUndo() {
      const params = { ids: [] }
      let ids = []
      this.page.list.forEach(item => {
        if (item.isSelected) {
          ids.push(item.orderNo)
        }
      })
      if (ids.length === 0) {
        return this.$message.warning('请选择数据！')
      } else {
        params.ids = ids
      }
      this.$confirm('是否取消已选中的订单?', '取消发货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$api.logisticsUndoArrange(params).then((res) => {
          if (res.code === 0) {
            this.fetchData('search')
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            console.log('失败')
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onChangeLogisticsStatus1(status) {
      let arr = this.itemListAll1
      this.searchFormConfig3.formconfig.itemList = JSON.parse(JSON.stringify(arr))
      if (status == '5') {
        this.searchFormConfig3.formconfig.itemList.splice(5, 1)
        this.columns3 = this.columns5
      } else {
        this.searchFormConfig3.formconfig.itemList.splice(8, 1)
        if (status != '') {
          this.columns3 = this.columns4
        } else {
          this.columns3 = this.columns3x
        }
      }
      this.searchFormConfig3.formconfig.itemList.forEach((item, index) => {
        if (item.prop == 'logisticsCompanyCode') {
          this.searchFormConfig3.formconfig.itemList[index].option = this.logisticsCompanyList
        }

        if (item.prop == 'multipleBagFlag') {
          let list = [{ label: '是', value: true }, { label: '否', value: false }]
          this.searchFormConfig3.formconfig.itemList[index].option = list
        }
      })
      this.searchFormConfig3.formData.status = status
      this.currentStatus1 = status
      this.pageNo3 = 1
      this.fetchData3('search')
    },
    onChangeLogisticsStatus(status) {
      console.log(status)
      // this.form = Object.assign({}, {})
      const columnCommon = this.columnCommon
      const columnMiddle = this.columnMiddle
      this.currentStatus = status
      this.page.status = status
      if (status == '6') {
        this.extraStatus = '1'
      } else if (status == '7') {
        this.extraStatus = '2'
      } else {
        this.extraStatus = ''
      }
      if (status === '') {
        this.page.status = ''

      } else {
        this.searchFormVal.statusL = ''
      }
      this.multipleSelection = [] // 切换列表时清空已选项
      this.columns = []
      // 全部
      if (this.currentStatus === this.logisticsStatus.all.values || this.currentStatus === this.logisticsStatus.yAccept.values || this.currentStatus === this.logisticsStatus.yClose.values) {
        this.columns = columnCommon.concat(this.columnAll)
      }
      // 自提中
      if (this.currentStatus == 9) {
        this.columns = columnCommon.concat(columnMiddle)
        this.setListOperation()
      }
      // 待备货
      if (this.currentStatus === this.logisticsStatus.stayStockUp.values) {
        this.columns = columnCommon.concat(columnMiddle)
        this.setListOperation()
      }
      // 已备货
      if (this.currentStatus === this.logisticsStatus.stockUp.values) {
        this.columns = columnCommon.concat(columnMiddle)
        this.setListOperation()
      }
      // 待发货
      if (this.currentStatus === this.logisticsStatus.stayDeliverGoods.values) {
        this.columns = columnCommon.concat(columnMiddle)
        this.setListOperation()
      }
      // 已发货
      if (this.currentStatus === this.logisticsStatus.deliverGoods.values) {
        const colStatus = {
          label: '物流状态', minWidth: '100',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.logisticsExceptionStatus ? '异常' : '正常'}</p>
              </div>
            )
          }
        }
        this.columns = columnCommon.concat(columnMiddle)
        this.columns.splice(11, 0, colStatus)

        this.setListOperation()
      }
      // 售后件
      if (this.currentStatus === this.logisticsStatus.afterSale.values) {
        this.columns = [...columnCommon, ...this.columnAfterSale]
        this.searchFormConfig.formconfig.itemList = this.itemListAll
        this.setSearchDictionaries('售后状态', 'after_sale_status')
        this.setSearchDictionaries('售后原因', 'after_sale_reason')
        this.itemListAll.forEach((item) => {
          item = this.copyObj(item)
        })
        let arr = this.itemListAll
        this.searchFormConfig.formconfig.itemList = JSON.parse(JSON.stringify(arr))
        this.searchFormConfig.formconfig.itemList.splice(14, 2)
      } else {

        this.itemListSplice.forEach((item) => {
          item = this.copyObj(item)
        })
        let arr = this.itemListSplice
        this.searchFormConfig.formconfig.itemList = JSON.parse(JSON.stringify(arr))
        // if (this.currentStatus) {
        //   this.searchFormConfig.formconfig.itemList.splice(11, 1)
        // }
        if (this.currentStatus == 1 || this.currentStatus == 3) {
          this.searchFormConfig.formconfig.itemList.splice(11, 2)
        } else if (this.currentStatus == 2 || this.currentStatus == 4) {
          this.searchFormConfig.formconfig.itemList.splice(11, 1)
        }

      }
      this.page.pageNo = 1
      this.page.pageSize = 10
      this.page.currentPage = 1
      // this.$refs.formAttr.submitForm('ruleForm', '')
      console.log(this.searchFormVal)
      this.fetchData('search')
    },
    copyObj(obj) {
      let newObj = {};
      for (let key in obj) {
        if (typeof obj[key] == 'object') {//如:key是wife,引用类型,那就递归
          newObj[key] = this.copyObj(obj[key])
        } else {//基本类型,直接赋值
          newObj[key] = obj[key];
        }
      }
      return newObj;
    },
    setListOperation(type, jurisdiction) {
      // 权限 显示
      // const jurisdiction = "<el-link type='primary' size='mini' type='primary'>jurisdiction</el-link>"
      const currentStatus = this.currentStatus
      const parArray = this.parArray
      const operation = {
        label: '操作',
        width: '230',
        fixed: 'right',
        render: (h, scope) => {
          let pp = '';
          if (scope.row.hasTask === 1 && scope.row.splitType === 0) {
            pp = <el-link type='primary' size='mini' onClick={() => { this.showDialog('审核流程', '640px', 'shenheStep', scope.row, scope.$index) }}>进度</el-link>
          }
          let isOptions = false
          if (scope.row.splitOrderList) {
            isOptions = scope.row.splitOrderList.some(item => { return item.splitOrderList != null })
          }
          let p1 = ''
          if (scope.row.splitType == 0 && scope.row.splitFlag == 0) {
            p1 = <div>
              <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                this.toOtherPages('orderDetails', scope.row, 'logistics')
              }}>查看
              </el-link>
              <el-link class={scope.row.ebillFlag == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                this.showDialog('修改物流单号', '500px', 'modifyOrderNoOne', scope.row, scope.$index)
              }}>修改物流单号
              </el-link>
              <el-link type='primary' size='mini' onClick={() => {
                this.showDialog('物流信息', '640px', 'logisticsMessageOne', scope.row, scope.$index)
              }}>物流信息
              </el-link>
              <el-link type='primary' size='mini' onClick={() => {
                this.wuliuAbnormal(scope.row)
              }}>物流异常
              </el-link>
              {/* <el-link type='primary' size='mini' onClick={() => { this.showDialog('审核流程', '640px', 'shenheStep', scope.row, scope.$index) }}>进度</el-link> */}
              {pp}
            </div>
          } else {
            if (scope.row.splitType == 0) {
              p1 = <div>
                <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                  this.toOtherPages('orderDetails', scope.row, 'logistics')
                }}>查看
                </el-link>
                <el-link type='primary' size='mini' onClick={() => {
                  this.wuliuAbnormal(scope.row)
                }}>物流异常
                </el-link>
                {/* <el-link type='primary' size='mini' onClick={() => { this.showDialog('审核流程', '640px', 'shenheStep', scope.row, scope.$index) }}>进度</el-link> */}
                {pp}
              </div>
            } else if (scope.row.splitType == 1 && scope.row.splitFlag == 0) {
              // ebillFlag:1  电子面单 不显示修改物流号
              p1 = <div>
                <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                  this.toOtherPages('orderDetails', scope.row, 'logistics')
                }}>查看
                </el-link>
                <el-link type='primary' size='mini' onClick={() => {
                  this.showDialog('物流信息', '640px', 'logisticsMessageOne', scope.row, scope.$index)
                }}>物流信息
                </el-link>
                <el-link type='primary' size='mini' class={scope.row.ebillFlag == 0 ? 'info' : 'hide-content info'} onClick={() => {
                  this.showDialog('修改物流单号', '500px', 'modifyOrderNoOne', scope.row, scope.$index)
                }}>修改物流单号
                </el-link>
              </div>
            } else if (scope.row.splitType == 1 && scope.row.splitFlag == 1) {
              p1 = <div>
                <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                  this.toOtherPages('orderDetails', scope.row, 'logistics')
                }}>查看
                </el-link>
                <el-link type='primary' size='mini' onClick={() => {
                  this.showDialog('物流信息', '640px', 'logisticsMessageOne', scope.row, scope.$index)
                }}>物流信息
                </el-link>
                <el-link type='primary' size='mini' class={scope.row.ebillFlag == 0 ? 'info' : 'hide-content info'} onClick={() => {
                  this.showDialog('修改物流单号', '500px', 'modifyOrderNoOne', scope.row, scope.$index)
                }}>修改物流单号
                </el-link>
              </div>
            } else {
              p1 = <div>
                <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                  this.toOtherPages('orderDetails', scope.row, 'logistics')
                }}>查看
                </el-link>
              </div>
            }

          }
          console.log(isOptions)
          switch (currentStatus) {
            case 1: // 待备货
              // console.log('待备货')

              return (
                <div>
                  <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                    this.toOtherPages('orderDetails', scope.row, 'logistics')
                  }}>查看
                  </el-link>
                  <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' type='danger' onClick={() => { this.showDialog('关闭订单', '640px', 'closeOrder', scope.row, scope.$index) }}>关闭订单</el-link>
                  <el-link type='primary' size='mini' onClick={() => {
                    this.onStockUp(false, scope.row)
                  }}>备货
                  </el-link>
                  {/* <el-link type='primary' size='mini' onClick={() => { this.showDialog('审核流程', '640px', 'shenheStep', scope.row, scope.$index) }}>进度</el-link> */}
                  {pp}
                </div>
              )
              break
            case 2: // 已备货
              // console.log('已备货')
              return (
                <div>
                  <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                    this.toOtherPages('orderDetails', scope.row, 'logistics')
                  }}>查看
                  </el-link>

                  <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' type='danger' onClick={() => { this.showDialog('关闭订单', '640px', 'closeOrder', scope.row, scope.$index) }}>关闭订单</el-link>
                  {/* <el-link type='primary' size='mini' onClick={() => { this.showDialog('审核流程', '640px', 'shenheStep', scope.row, scope.$index) }}>进度</el-link> */}
                  {pp}
                  <el-link class={(scope.row.splitType == 0 || scope.row.splitType == 1) && !isOptions ? 'info' : 'hide-content info'} type='primary' onClick={() => { this.toOtherPages('splitOrder', scope.row, 'splitOrder') }}>订单拆单</el-link>
                  <el-link class={(scope.row.splitType == 0 || scope.row.splitType == 1) && (scope.row.splitOrderList && scope.row.splitOrderList.length > 0) ? 'info' : 'hide-content info'} type='primary' onClick={() => { this.qSplitOrder(scope.row) }}>撤销拆单</el-link>
                  <el-link type='danger' size='mini' class={(scope.row.orderGenerateType === 2 && parArray.includes('operationOrde_outStock')) ? '' : 'hide-content'} onClick={() => {
                    this.showDialog('缺货处理', '640px', 'outStock', scope.row)
                  }}>缺货处理</el-link>
                </div>
              )
              break
            case 3: // 待发货
              // console.log('待发货')
              return (
                <div>
                  <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                    this.toOtherPages('orderDetails', scope.row, 'logistics')
                  }}>查看
                  </el-link>
                  {/* 有拆单且母单才发货 */}
                  <el-link type='primary' size='mini' class={scope.row.splitType == 2 || (scope.row.splitType == 0 && (scope.row.splitOrderList && scope.row.splitOrderList.length > 0)) ? 'hide-content' : ''} onClick={() => {
                    this.showDialog('发货', '500px', 'modifyOrderNoOne', scope.row, scope.$index)
                  }}>发货
                  </el-link>
                  <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='danger' onClick={() => { this.showDialog('关闭订单', '640px', 'closeOrder', scope.row, scope.$index) }}>关闭订单</el-link>
                  {/* <el-link type='primary' size='mini' onClick={() => { this.showDialog('审核流程', '640px', 'shenheStep', scope.row, scope.$index) }}>进度</el-link> */}
                  {pp}
                  {/*自动订单才显示缺货处理   母单不显示缺货*/}
                  <el-link type='danger' size='mini' class={(scope.row.orderGenerateType === 2 && parArray.includes('operationOrde_outStock')) && scope.row.splitType == 0 ? '' : 'hide-content'} onClick={() => {
                    this.showDialog('缺货处理', '640px', 'outStock', scope.row)
                  }}>缺货处理</el-link>
                </div>
              )
              break
            case 9: // 自提中
              return (
                <div>
                  <el-link class={scope.row.splitType == 0 ? 'info' : 'hide-content info'} type='primary' size='mini' onClick={() => {
                    this.toOtherPages('orderDetails', scope.row, 'logistics')
                  }}>查看
                  </el-link>
                </div>
              )
              break
            default: // 已发货
              // console.log('已发货')
              return (
                <div>{p1}</div>
              )
          }
        }
      }
      this.columns.push(operation)
      // console.log(this.columns[this.columns.length - 1])
    },
    // 缺货处理
    onOutStock() {
      const params = {
        orderNo: this.dialog.row.orderNo,
      }
      this.$api.outStock(params).then((res) => {
        if (res.code === 0) {
          this.$message.success('操作成功!')
          this.fetchData('search')
        }
        this.dialog.visible = false
      }).catch((err) => {
        console.log(err)
        this.dialog.visible = false
      })
    },
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'logisticsOrder'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })
    },
    // 导出记录列表查询
    onApplierExport(type) {
      this.dialog.visible = true
      this.dialog.title = '导出记录'
      this.dialog.width = '745px'
      this.dialog.type = 'deriveRecord'

      const params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        // status: 2
        type: type
      }
      /*
      params = Object.assign(params, this.searchForm)
      params.orgCode = params.orgCode[params.orgCode.length - 1]
      */

      // const searchForm = this.searchFormVal
      // // params = Object.assign(params, searchForm)
      // if (params.postTime) {
      //   params.postTimeStart = params.postTime[0]
      //   params.postTimeEnd = params.postTime[1]
      // }
      // if (params.createdTime) {
      //   params.createdTimeStart = params.createdTime[0]
      //   params.createdTimeEnd = params.createdTime[1]
      // }
      // // params.categoryId = searchForm.categoryId[searchForm.categoryId.length - 1]
      // // 去除字符串 前后 空格
      // for (const item in params) {
      //   if (typeof params[item] === 'string') {
      //     params[item] = params[item].trim()
      //   }
      // }

      this.$api.logisticsRecordsPage(params).then((res) => {
        if (res.code == 0) {
          this.deriveRecordList = res.data
        }
        // this.downloadlink(res.data)
      }).catch((err) => {
        console.log(err)
      })
    },
    parseOrgCodeMutil(paramsOrgCode) {
      let tempOrgCode = []
      for (let i = 0; i < paramsOrgCode.length; i++) {
        if (paramsOrgCode[i]) {
          tempOrgCode.push(paramsOrgCode[i][paramsOrgCode[i].length - 1])
        }
      }
       return tempOrgCode.join(',')
    }
    // downloadlink (url) {
    //   const iframe = document.createElement('iframe')
    //   iframe.style.display = 'none'
    //   iframe.src = url
    //   document.body.appendChild(iframe)
    // }
  }
}
</script>
<style lang="scss">
/* 改变三角形颜色 */
/* 朝上 */
.atooltipL[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: #ffffff;
}

/* 朝下 */
.atooltipL[x-placement^="top"] .popper__arrow:after {
  border-top-color: #ffffff;
}

/* 改变三角形外边框 */
/* 三角形朝下的时候 */
.atooltipL[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #ffffff !important;
}

/* 三角形朝上的时候 */
.atooltipL[x-placement^="top"] .popper__arrow {
  border-top-color: #ffffff !important;
}

/* 自定义内容的区域的颜色 */
.atooltipL {
  width: 193px;
  height: auto;
  background: #ffffff !important;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: none;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #303033 !important;
}
</style>
<style scoped lang="scss">
::v-deep .search-form1 {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    width: 100%;
    max-width: 340px;
    min-width: 299px;

    .el-form-item__label {
      width: 100px;
    }

    .el-form-item__content {
      width: calc(100% - 100px);

      .el-select,
      .el-date-editor,
      .el-cascader {
        width: 100%
      }
    }
  }
}

.activeModel {
  background: #FFFFFF;
  border: 1px solid #4168E7;
  opacity: 1;
  border-radius: 0px;
}

::v-deep .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
  z-index: 1;
  right: 20px;
}

/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  left: 20px;
}

/*显示文字*/
::v-deep .el-switch__label.is-active {
  display: block;
}

::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px !important;
}


.cBtn {
  width: 120px;
  height: 36px;
  border: 1px solid #D9D9D9;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #999999;
  text-align: center;
  cursor: pointer;
  margin-right: 12px;
}

.qBtn {
  width: 120px;
  height: 36px;
  background: #4168E7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

/deep/ .hide-content {
  display: none !important;
}

/deep/ .el-button {
  border: none;
}

/deep/ .el-link {
  margin: 0 5px;
}

/deep/ .el-table th>.cell,
/deep/ .el-table td {
  text-align: unset;
}

.but-list:after {
  clear: both;
  display: table;
  content: "";
}

.stock-up-send-but1 {
  width: 132px;
  height: 36px;
  background: #12AB62;
  border-radius: 4px;
  color: #FFFFFF;
  text-align: center;
  // line-height: 36px;
}

.stock-up-send-but2 {
  width: 160px;
  height: 36px;
  background-color: #7763DD;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

.stock-up-send-but3 {
  width: 120px;
  height: 34px;
  border: 1px solid #4168E7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #4168E7;
  text-align: center;
  cursor: pointer;
  margin-left: 20px;
}

.stock-up-send-but4 {
  width: 120px;
  height: 36px;
  background-color: #7763DD;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

.stock-up-send-but5 {
  width: 120px;
  height: 36px;
  background-color: #4168E7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
  margin-right: 20px;
}

.but-list {
  margin-bottom: 20px;

  .left {
    float: left;

    /deep/ .el-button {
      width: 120px;
      height: 36px;
      border-radius: 4px;
      font-size: 16px;
    }
  }

  .right {
    float: right;

    /deep/ .el-button {
      min-width: 120px;
      height: 36px;
      border-radius: 4px;
      font-size: 16px;
    }

    // 批量备货
    .stay-stock-up-but {
      color: #409eff;
      border: 1px solid #409eff;
      background-color: #ffffff;
    }



    // 导出发货
    .stock-up-send-but {
      width: 120px;
      height: 36px;
      background: #4168E7;
      opacity: 1;
      border-radius: 4px;
    }

    .stock-up-send-but1 {
      width: 132px;
      height: 36px;
      background: #12AB62;
      opacity: 1;
      border-radius: 4px;
      line-height: 1;
    }

    .stock-up-send-but2 {
      width: 132px;
      height: 36px;
      background: #FF0000;
      opacity: 1;
      border-radius: 4px;
      line-height: 1;
    }

    // 导出记录
    .stock-up-record-but {
      background-color: #7763dd;
    }

    // 导出物流单
    .stay-deliver-goods-but {}

    // 批量修改物流单号
    .deliver-goods-but {
      width: 160px;
      height: 36px;
      border: 1px solid #4168e7;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 400;
      color: #4168e7;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .cancel {
    width: 120px;
    height: 36px;
    border: 1px solid #d9d9d9;
    opacity: 1;
    border-radius: 4px;
  }

  .affirm {
    width: 120px;
    height: 36px;
    background: #4168e7;
    opacity: 1;
    border-radius: 4px;
  }
}

/deep/ .el-upload-dragger {
  width: 600px !important;
}

.dialogBtnright {
  display: flex;
  justify-content: space-between;
}

.dialogBtnright_right {
  display: flex;
  justify-content: right !important;
}

.setPay_payment_btn_quxiao {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  color: rgba(153, 153, 153, 1);
  border-radius: 4px;
  line-height: 0;
}

.setPay_payment_btn_queren {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  border: 0;
}

.block {
  text-align: right;
}

.setPay_payment {
  display: block;
  margin-bottom: 15px;
}

.dialog-btn {
  text-align: right;
}

/deep/ .el-table__row td .cell span,
/deep/ .el-table__row td .cell div p {
  display: block;
  //overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
}

.wuliuAbnormal_box {
  display: flex;
  margin-bottom: 20px;
}

.radio_group {
  margin-left: 20px;
}

.radio_group_item {
  margin-bottom: 10px;
}

.wuliuAbnormal_box_title {
  margin-top: -5px;
}

/deep/.el-select {
  border-left: none;
  border-right: none;

  input {
    border-left: 1px solid #d8dce5 !important;
    border-right: 1px solid #d8dce5 !important;
    border-radius: 5px !important;
  }
}

/deep/.el-scrollbar {
  height: 10px;
}

/deep/.el-scrollbar__bar.is-horizontal {
  height: 9px;
}
</style>
